{
  "en": {
    "{0} из {1} знаков": "{0} of {1} characters",
    "5 ошибок новичка в беге": "5 beginner running mistakes",
    "А другу отправьте, чтобы тоже не забыл": "And send it to a friend so they don’t forget either",
    "Без воды и оправданий": "No fluff, no excuses",
    "Без паники": "Don’t panic",
    "Белый фон и крупный чёрный шрифт": "White background and large black type",
    "Бот уже прислал карусель с текстом поста в чат, в отдельную тему. Текст правится прямо на слайде, без новой генерации.": "The bot has already sent the carousel with the post text to the chat, in a separate topic. The text is edited right on the slide, without a new generation.",
    "Ваш ход": "Your move",
    "Ваши фото и текст на плашке": "Your photos and text on a panel",
    "Вдохновляющий": "Inspiring",
    "ВКонтакте и Telegram": "VK and Telegram",
    "Все оформления": "All designs",
    "встанут на слайды по порядку": "go on the slides in order",
    "Выберите одно простое действие и сделайте его в ближайшие сутки.": "Pick one simple action and do it within the next day.",
    "Гардероб": "Wardrobe",
    "Главная ошибка": "The main mistake",
    "Дерзкий": "Bold",
    "Для старта": "To get started",
    "До {0} фото, {1}": "Up to {0} photos, {1}",
    "Журнал": "Magazine",
    "за карусель": "per carousel",
    "Завтраки": "Breakfasts",
    "Заголовок слайда": "Slide title",
    "Загружаем фото": "Uploading photos",
    "Задайте их в комментариях, ответим": "Ask in the comments, we’ll answer",
    "Заметки": "Notes",
    "Запишите цель на видном месте и отмечайте каждый день, когда сделали шаг.": "Write your goal somewhere visible and mark each day you take a step.",
    "Заряжает начать": "Gets you started",
    "И отправьте другу, которому это пригодится": "And send it to a friend who needs it",
    "Изменить стиль": "Change style",
    "Изменить текст": "Edit text",
    "Изменить тему": "Change the topic",
    "Иллюстрации готовы": "Illustrations ready",
    "Искать среди {0} {1}": "Search among {0} {1}",
    "Истории": "Stories",
    "Истории с продолжением": "Stories to be continued",
    "Каждый шаг считается": "Every step counts",
    "Как другу за кофе": "Like a chat over coffee",
    "Как мы открыли кофейню с нуля": "How we opened a coffee shop from scratch",
    "Как понять, что получается": "How to tell it’s working",
    "карусель": "carousel",
    "Карусель готова": "Carousel ready",
    "Карусель для поста": "Post carousel",
    "карусель не создана": "the carousel was not created",
    "Коротко": "Short",
    "Коротко и по делу": "Short and to the point",
    "Коротко о главном": "The essentials in brief",
    "Крупная цитата, портрет и рассказ от первого лица": "A big quote, a portrait and a first-person story",
    "Лаконичный": "Concise",
    "Легко и с улыбкой": "Light and with a smile",
    "Лист в линейку и выделение маркером": "Lined paper and highlighter",
    "Листайте": "Swipe",
    "Листайте, тут всё по делу": "Swipe, it’s all to the point",
    "Личные истории и отзывы": "Personal stories and reviews",
    "Минимал": "Minimal",
    "Мифы о сне": "Sleep myths",
    "Мифы о сне, в которые пора перестать верить": "Sleep myths it’s time to stop believing",
    "Мнения, истории и треды": "Opinions, stories and threads",
    "Можно без темы: текст по фото": "No topic needed: text from the photos",
    "Можно вставить готовый текст": "You can paste ready text",
    "Можно уйти с экрана: бот напишет, когда карусель будет готова.": "You can leave the screen: the bot will message you when the carousel is ready.",
    "на слайдах": "on the slides",
    "Напишите тему от {0} знаков или добавьте фото": "Write a topic of {0}+ characters or add photos",
    "Например: {0}": "For example: {0}",
    "Начните сегодня": "Start today",
    "Не получилось собрать карусель": "Could not build the carousel",
    "Неделя полезных завтраков": "A week of healthy breakfasts",
    "Несколько кадров из моей недели": "A few shots from my week",
    "Ну что, узнали себя?": "So, sound familiar?",
    "О чём пост": "What the post is about",
    "О чём пост?": "What is the post about?",
    "Обзоры, подборки и мода": "Reviews, roundups and fashion",
    "Окружение, которое поддерживает, и понятный план на неделю вперёд.": "Supportive people around you and a clear plan for the week ahead.",
    "Осенний гардероб: вещи на весь сезон": "Autumn wardrobe: pieces for the whole season",
    "Остались вопросы?": "Any questions?",
    "Отметьте друга, который так делает": "Tag a friend who does this",
    "Ошибки в беге": "Running mistakes",
    "Панорама": "Panorama",
    "Первый шаг уже сделан": "The first step is done",
    "Перед отпуском": "Before vacation",
    "Перерисовываем слайд…": "Redrawing the slide…",
    "Пишем подпись и хештеги": "Writing the caption and hashtags",
    "Пишем текст слайдов": "Writing the slide text",
    "по одному на слайд, по кругу": "one per slide, in a loop",
    "Подписывайтесь: дальше больше пользы": "Follow for more useful posts",
    "Подпись готова": "Caption ready",
    "Подтвердите права на фото": "Confirm the rights to the photos",
    "Подтверждаю право использовать загружаемые фото": "I confirm the right to use the uploaded photos",
    "Подходит для": "Suits",
    "Полезное": "Useful",
    "Пост-скриншот": "Post screenshot",
    "Почему это важно": "Why it matters",
    "Пошаговые инструкции": "Step-by-step guides",
    "Права на свои фото": "Rights to your photos",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "The edit is not confirmed. Continue checking the same request.",
    "Предпросмотр слайдов": "Slide preview",
    "Предыдущий слайд": "Previous slide",
    "Пригодилось?": "Was it useful?",
    "Пригодится": "It’ll come in handy",
    "Проверьте текст слайда: сервер его не принял.": "Check the slide text: the server did not accept it.",
    "Простой приём": "A simple trick",
    "пункт": "point",
    "пункта": "points",
    "пунктов": "points",
    "Путешествия, события и товары": "Travel, events and products",
    "Пытаться сделать всё сразу. Маленький шаг каждый день лучше рывка раз в месяц.": "Trying to do everything at once. A small step every day beats a sprint once a month.",
    "Разберёмся, что даёт эта тема и почему о ней стоит знать уже сегодня.": "Let’s see what this topic gives and why it’s worth knowing today.",
    "Разбор": "Breakdown",
    "Разбор по пунктам": "Point-by-point breakdown",
    "Регулярность важнее идеальности. Начните с малого и не бросайте.": "Consistency beats perfection. Start small and keep going.",
    "Рисуем иллюстрации": "Drawing illustrations",
    "С фото": "With photos",
    "С чего начать": "Where to start",
    "С юмором": "Humorous",
    "Самое важное": "What matters most",
    "Свои фото": "Your photos",
    "Своя кофейня": "Own coffee shop",
    "Сколько ждать результата? Первые перемены обычно видны через две-три недели.": "How long until results? The first changes usually show in two or three weeks.",
    "Сколько слайдов": "How many slides",
    "слайд": "slide",
    "Слайд {0} из {1}": "Slide {0} of {1}",
    "Слайд как пост в соцсети: аватар, имя, текст": "Slide as a social post: avatar, name, text",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "The slide has already been changed. We refreshed the result — check the text and save again.",
    "слайда": "slides",
    "слайдов": "slides",
    "Слайды ещё загружаются": "The slides are still loading",
    "Слайды собраны": "Slides assembled",
    "Следующий слайд": "Next slide",
    "Смело и с вызовом": "Daring and provocative",
    "Смотрим ваши фото": "Looking at your photos",
    "Собираем карусель": "Building the carousel",
    "Собираем слайды": "Assembling the slides",
    "Советы и гайды": "Tips and guides",
    "Создать карусель": "Create carousel",
    "Создать карусель · {0} C": "Create carousel · {0} C",
    "Сохраните": "Save it",
    "Сохраните и отправьте тому, кто тоже начинает": "Save it and send it to someone who is starting too",
    "Сохраните и поделитесь": "Save and share",
    "Сохраните и проверьте на себе": "Save it and try it yourself",
    "Сохраните пост и вернитесь к нему, когда нужна поддержка": "Save the post and come back to it when you need support",
    "Сохраните пост и начните завтра": "Save the post and start tomorrow",
    "Сохраните пост и поделитесь им с друзьями": "Save the post and share it with friends",
    "Сохраните разбор": "Save the breakdown",
    "Сохраните, пока не забыли": "Save it before you forget",
    "Сохраните, пригодится": "Save it, it’ll come in handy",
    "Сохраните, чтобы не потерять": "Save it so you don’t lose it",
    "Списки": "Lists",
    "Спокойно, это лечится": "Relax, it’s fixable",
    "Сравнивайте себя с собой месяц назад, а не с другими.": "Compare yourself to who you were a month ago, not to others.",
    "стилей": "styles",
    "Стили": "Styles",
    "Стиль «{0}»": "Style “{0}”",
    "Стиль поста": "Post style",
    "Стиль шаблона": "Template style",
    "стиля": "style",
    "Текст выделен: скопируйте его вручную": "The text is selected: copy it manually",
    "Текст длиннее {0} знаков": "The text is longer than {0} characters",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "The text does not fit on the slide. Shorten the heading or the text.",
    "Текст по вашим фото": "Text from your photos",
    "Текст слайда": "Slide text",
    "Тема не прошла проверку": "The topic did not pass the check",
    "Тема разобрана": "Topic analyzed",
    "Тёмный": "Dark",
    "Только проверенные факты": "Only verified facts",
    "Тон": "Tone",
    "тон {0}": "{0} tone",
    "Тут откроется тема чата, куда бот прислал карусель": "This will open the chat topic where the bot sent the carousel",
    "У вас получится": "You’ve got this",
    "У каждого слайда свой цвет и крупная цифра": "Each slide has its own color and a big number",
    "Узнали себя? Листайте": "Sound familiar? Swipe",
    "Факты и цифры без воды": "Facts and figures, no fluff",
    "Фон и линия перетекают со слайда на слайд": "The background and line flow from slide to slide",
    "Фото и антиква, подписи как в журнале": "Photos and serif type, magazine-style captions",
    "Фото на весь слайд": "Full-slide photo",
    "Фото разобраны": "Photos reviewed",
    "Хватит откладывать": "Stop putting it off",
    "Цветные блоки": "Color blocks",
    "Цена": "Price",
    "Цитата и история": "Quote and story",
    "Частый вопрос": "A common question",
    "Чек-лист": "Checklist",
    "Чек-лист перед отпуском": "Pre-vacation checklist",
    "Чек-листы и планы": "Checklists and plans",
    "Чёрный фон, светлый текст и один акцент": "Black background, light text and one accent",
    "Честно": "Honestly",
    "Честно и без прикрас": "Honest and unvarnished",
    "Читаем тему": "Reading the topic",
    "Что запомнить": "What to remember",
    "Что поможет": "What helps",
    "Шаг {0}": "Step {0}",
    "Шаги с галочками и полоса прогресса": "Ticked steps and a progress bar",
    "Шпаргалки и личные советы": "Cheat sheets and personal tips",
    "Экспертные посты и цифры": "Expert posts and numbers",
    "Этот вариант пока недоступен": "This option is not available yet",
    "Этот слайд больше нельзя изменить.": "This slide can no longer be edited.",
    "Этот слайд нельзя изменить": "This slide cannot be edited"
  },
  "hy": {
    "{0} из {1} знаков": "{0}՝ {1} նիշից",
    "5 ошибок новичка в беге": "Սկսնակ վազորդի 5 սխալ",
    "А другу отправьте, чтобы тоже не забыл": "Եվ ուղարկեք ընկերոջը, որ նա էլ չմոռանա",
    "Без воды и оправданий": "Առանց ավելորդության և արդարացումների",
    "Без паники": "Առանց խուճապի",
    "Белый фон и крупный чёрный шрифт": "Սպիտակ ֆոն և խոշոր սև տառատեսակ",
    "Бот уже прислал карусель с текстом поста в чат, в отдельную тему. Текст правится прямо на слайде, без новой генерации.": "Բոտն արդեն ուղարկել է կարուսելը գրառման տեքստով չաթ՝ առանձին թեմայում։ Տեքստը խմբագրվում է հենց սլայդի վրա՝ առանց նոր գեներացիայի։",
    "Ваш ход": "Ձեր քայլն է",
    "Ваши фото и текст на плашке": "Ձեր լուսանկարները և տեքստը վահանակի վրա",
    "Вдохновляющий": "Ոգեշնչող",
    "ВКонтакте и Telegram": "VK և Telegram",
    "Все оформления": "Բոլոր ձևավորումները",
    "встанут на слайды по порядку": "կտեղադրվեն սլայդներին հերթով",
    "Выберите одно простое действие и сделайте его в ближайшие сутки.": "Ընտրեք մեկ պարզ քայլ և արեք այն առաջիկա օրվա ընթացքում։",
    "Гардероб": "Զգեստապահարան",
    "Главная ошибка": "Գլխավոր սխալը",
    "Дерзкий": "Համարձակ",
    "Для старта": "Սկզբի համար",
    "До {0} фото, {1}": "Մինչև {0} լուսանկար, {1}",
    "Журнал": "Ամսագիր",
    "за карусель": "մեկ կարուսելի համար",
    "Завтраки": "Նախաճաշեր",
    "Заголовок слайда": "Սլայդի վերնագիր",
    "Загружаем фото": "Վերբեռնում ենք լուսանկարները",
    "Задайте их в комментариях, ответим": "Գրեք մեկնաբանություններում, կպատասխանենք",
    "Заметки": "Նշումներ",
    "Запишите цель на видном месте и отмечайте каждый день, когда сделали шаг.": "Գրեք նպատակը տեսանելի տեղում և նշեք ամեն օրը, երբ քայլ եք արել։",
    "Заряжает начать": "Մղում է սկսելու",
    "И отправьте другу, которому это пригодится": "Եվ ուղարկեք ընկերոջը, ում դա պետք կգա",
    "Изменить стиль": "Փոխել ոճը",
    "Изменить текст": "Փոխել տեքստը",
    "Изменить тему": "Փոխել թեման",
    "Иллюстрации готовы": "Պատկերազարդումները պատրաստ են",
    "Искать среди {0} {1}": "Որոնել {0} {1} մեջ",
    "Истории": "Պատմություններ",
    "Истории с продолжением": "Շարունակություն ունեցող պատմություններ",
    "Каждый шаг считается": "Ամեն քայլ հաշվի է",
    "Как другу за кофе": "Ինչպես ընկերոջը սուրճի շուրջ",
    "Как мы открыли кофейню с нуля": "Ինչպես զրոյից բացեցինք սրճարան",
    "Как понять, что получается": "Ինչպես հասկանալ, որ ստացվում է",
    "карусель": "կարուսել",
    "Карусель готова": "Կարուսելը պատրաստ է",
    "Карусель для поста": "Կարուսել գրառման համար",
    "карусель не создана": "կարուսելը չի ստեղծվել",
    "Коротко": "Համառոտ",
    "Коротко и по делу": "Կարճ և ըստ էության",
    "Коротко о главном": "Կարճ՝ գլխավորի մասին",
    "Крупная цитата, портрет и рассказ от первого лица": "Խոշոր մեջբերում, դիմանկար և պատմություն առաջին դեմքով",
    "Лаконичный": "Հակիրճ",
    "Легко и с улыбкой": "Թեթև և ժպիտով",
    "Лист в линейку и выделение маркером": "Գծավոր թերթ և մարկերով ընդգծում",
    "Листайте": "Թերթեք",
    "Листайте, тут всё по делу": "Թերթեք, այստեղ ամեն ինչ ըստ էության է",
    "Личные истории и отзывы": "Անձնական պատմություններ և կարծիքներ",
    "Минимал": "Մինիմալ",
    "Мифы о сне": "Քնի մասին առասպելներ",
    "Мифы о сне, в которые пора перестать верить": "Քնի մասին առասպելներ, որոնց ժամանակն է դադարել հավատալ",
    "Мнения, истории и треды": "Կարծիքներ, պատմություններ և թրեդներ",
    "Можно без темы: текст по фото": "Կարելի է առանց թեմայի՝ տեքստը լուսանկարներով",
    "Можно вставить готовый текст": "Կարելի է տեղադրել պատրաստի տեքստ",
    "Можно уйти с экрана: бот напишет, когда карусель будет готова.": "Կարող եք դուրս գալ էկրանից. բոտը կգրի, երբ կարուսելը պատրաստ լինի։",
    "на слайдах": "սլայդներում",
    "Напишите тему от {0} знаков или добавьте фото": "Գրեք {0} նիշից թեմա կամ ավելացրեք լուսանկարներ",
    "Например: {0}": "Օրինակ՝ {0}",
    "Начните сегодня": "Սկսեք այսօր",
    "Не получилось собрать карусель": "Չհաջողվեց հավաքել կարուսելը",
    "Неделя полезных завтраков": "Առողջ նախաճաշերի շաբաթ",
    "Несколько кадров из моей недели": "Մի քանի կադր իմ շաբաթից",
    "Ну что, узнали себя?": "Դե ինչ, ճանաչեցի՞ք ձեզ",
    "О чём пост": "Ինչի մասին է գրառումը",
    "О чём пост?": "Ինչի՞ մասին է գրառումը",
    "Обзоры, подборки и мода": "Ակնարկներ, ընտրանիներ և նորաձևություն",
    "Окружение, которое поддерживает, и понятный план на неделю вперёд.": "Աջակցող միջավայր և հասկանալի պլան առաջիկա շաբաթվա համար։",
    "Осенний гардероб: вещи на весь сезон": "Աշնանային զգեստապահարան՝ իրեր ամբողջ սեզոնի համար",
    "Остались вопросы?": "Հարցեր ունե՞ք",
    "Отметьте друга, который так делает": "Նշեք ընկերոջը, ով այդպես է անում",
    "Ошибки в беге": "Վազքի սխալներ",
    "Панорама": "Համայնապատկեր",
    "Первый шаг уже сделан": "Առաջին քայլն արդեն արված է",
    "Перед отпуском": "Արձակուրդից առաջ",
    "Перерисовываем слайд…": "Վերագծում ենք սլայդը…",
    "Пишем подпись и хештеги": "Գրում ենք ստորագրությունը և հեշթեգերը",
    "Пишем текст слайдов": "Գրում ենք սլայդների տեքստը",
    "по одному на слайд, по кругу": "մեկական յուրաքանչյուր սլայդին, շրջանով",
    "Подписывайтесь: дальше больше пользы": "Բաժանորդագրվեք՝ առաջ ավելի շատ օգուտ կլինի",
    "Подпись готова": "Ստորագրությունը պատրաստ է",
    "Подтвердите права на фото": "Հաստատեք լուսանկարների իրավունքը",
    "Подтверждаю право использовать загружаемые фото": "Հաստատում եմ վերբեռնվող լուսանկարներն օգտագործելու իրավունքը",
    "Подходит для": "Հարմար է",
    "Полезное": "Օգտակար",
    "Пост-скриншот": "Գրառման սքրինշոթ",
    "Почему это важно": "Ինչու է սա կարևոր",
    "Пошаговые инструкции": "Քայլ առ քայլ հրահանգներ",
    "Права на свои фото": "Ձեր լուսանկարների իրավունքները",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "Խմբագրումը չի հաստատվել։ Շարունակեք ստուգել նույն հարցումը։",
    "Предпросмотр слайдов": "Սլայդների նախադիտում",
    "Предыдущий слайд": "Նախորդ սլայդ",
    "Пригодилось?": "Օգտակա՞ր էր",
    "Пригодится": "Պետք կգա",
    "Проверьте текст слайда: сервер его не принял.": "Ստուգեք սլայդի տեքստը․ սերվերը այն չընդունեց։",
    "Простой приём": "Պարզ հնարք",
    "пункт": "կետ",
    "пункта": "կետ",
    "пунктов": "կետ",
    "Путешествия, события и товары": "Ճամփորդություններ, իրադարձություններ և ապրանքներ",
    "Пытаться сделать всё сразу. Маленький шаг каждый день лучше рывка раз в месяц.": "Փորձել ամեն ինչ միանգամից անել։ Ամեն օր փոքր քայլը լավ է, քան ամիսը մեկ պոռթկումը։",
    "Разберёмся, что даёт эта тема и почему о ней стоит знать уже сегодня.": "Պարզենք՝ ինչ է տալիս այս թեման և ինչու արժե իմանալ դրա մասին հենց այսօր։",
    "Разбор": "Վերլուծություն",
    "Разбор по пунктам": "Վերլուծություն կետ առ կետ",
    "Регулярность важнее идеальности. Начните с малого и не бросайте.": "Կանոնավորությունն ավելի կարևոր է, քան կատարելությունը։ Սկսեք փոքրից և մի՛ թողեք։",
    "Рисуем иллюстрации": "Նկարում ենք պատկերազարդումները",
    "С фото": "Լուսանկարներով",
    "С чего начать": "Որտեղից սկսել",
    "С юмором": "Հումորով",
    "Самое важное": "Ամենակարևորը",
    "Свои фото": "Ձեր լուսանկարները",
    "Своя кофейня": "Սեփական սրճարան",
    "Сколько ждать результата? Первые перемены обычно видны через две-три недели.": "Որքա՞ն սպասել արդյունքին։ Առաջին փոփոխությունները սովորաբար երևում են երկու-երեք շաբաթից։",
    "Сколько слайдов": "Քանի սլայդ",
    "слайд": "սլայդ",
    "Слайд {0} из {1}": "Սլայդ {0}՝ {1}-ից",
    "Слайд как пост в соцсети: аватар, имя, текст": "Սլայդը՝ սոցցանցի գրառման տեսքով՝ ավատար, անուն, տեքստ",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "Սլայդն արդեն փոխվել է։ Թարմացրինք արդյունքը․ ստուգեք տեքստը և նորից պահպանեք։",
    "слайда": "սլայդ",
    "слайдов": "սլայդ",
    "Слайды ещё загружаются": "Սլայդները դեռ բեռնվում են",
    "Слайды собраны": "Սլայդները հավաքված են",
    "Следующий слайд": "Հաջորդ սլայդ",
    "Смело и с вызовом": "Համարձակ և մարտահրավերով",
    "Смотрим ваши фото": "Դիտում ենք ձեր լուսանկարները",
    "Собираем карусель": "Հավաքում ենք կարուսելը",
    "Собираем слайды": "Հավաքում ենք սլայդները",
    "Советы и гайды": "Խորհուրդներ և ուղեցույցներ",
    "Создать карусель": "Ստեղծել կարուսել",
    "Создать карусель · {0} C": "Ստեղծել կարուսել · {0} C",
    "Сохраните": "Պահպանեք",
    "Сохраните и отправьте тому, кто тоже начинает": "Պահպանեք և ուղարկեք նրան, ով նույնպես սկսում է",
    "Сохраните и поделитесь": "Պահպանեք և կիսվեք",
    "Сохраните и проверьте на себе": "Պահպանեք և ստուգեք ձեր վրա",
    "Сохраните пост и вернитесь к нему, когда нужна поддержка": "Պահպանեք գրառումը և վերադարձեք դրան, երբ աջակցության կարիք ունենաք",
    "Сохраните пост и начните завтра": "Պահպանեք գրառումը և սկսեք վաղը",
    "Сохраните пост и поделитесь им с друзьями": "Պահպանեք գրառումը և կիսվեք ընկերների հետ",
    "Сохраните разбор": "Պահպանեք վերլուծությունը",
    "Сохраните, пока не забыли": "Պահպանեք, քանի դեռ չեք մոռացել",
    "Сохраните, пригодится": "Պահպանեք, պետք կգա",
    "Сохраните, чтобы не потерять": "Պահպանեք, որ չկորցնեք",
    "Списки": "Ցանկեր",
    "Спокойно, это лечится": "Հանգիստ, սա բուժելի է",
    "Сравнивайте себя с собой месяц назад, а не с другими.": "Համեմատեք ձեզ մեկ ամիս առաջվա ձեզ հետ, ոչ թե ուրիշների։",
    "стилей": "ոճերի",
    "Стили": "Ոճեր",
    "Стиль «{0}»": "«{0}» ոճ",
    "Стиль поста": "Գրառման ոճ",
    "Стиль шаблона": "Ձևանմուշի ոճ",
    "стиля": "ոճի",
    "Текст выделен: скопируйте его вручную": "Տեքստը նշված է․ պատճենեք այն ձեռքով",
    "Текст длиннее {0} знаков": "Տեքստը {0} նիշից երկար է",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "Տեքստը չի տեղավորվում սլայդում։ Կրճատեք վերնագիրը կամ տեքստը։",
    "Текст по вашим фото": "Տեքստ ձեր լուսանկարներով",
    "Текст слайда": "Սլայդի տեքստ",
    "Тема не прошла проверку": "Թեման չանցավ ստուգումը",
    "Тема разобрана": "Թեման վերլուծված է",
    "Тёмный": "Մուգ",
    "Только проверенные факты": "Միայն ստուգված փաստեր",
    "Тон": "Տոն",
    "тон {0}": "{0} տոն",
    "Тут откроется тема чата, куда бот прислал карусель": "Այստեղ կբացվի չաթի թեման, որտեղ բոտն ուղարկել է կարուսելը",
    "У вас получится": "Կստացվի",
    "У каждого слайда свой цвет и крупная цифра": "Յուրաքանչյուր սլայդ՝ իր գույնով և խոշոր թվով",
    "Узнали себя? Листайте": "Ճանաչեցի՞ք ձեզ։ Թերթեք",
    "Факты и цифры без воды": "Փաստեր և թվեր՝ առանց ավելորդության",
    "Фон и линия перетекают со слайда на слайд": "Ֆոնը և գիծը անցնում են սլայդից սլայդ",
    "Фото и антиква, подписи как в журнале": "Լուսանկարներ և անտիկվա, ամսագրային ստորագրություններ",
    "Фото на весь слайд": "Լուսանկար ամբողջ սլայդով",
    "Фото разобраны": "Լուսանկարները դիտված են",
    "Хватит откладывать": "Բավական է հետաձգել",
    "Цветные блоки": "Գունավոր բլոկներ",
    "Цена": "Գին",
    "Цитата и история": "Մեջբերում և պատմություն",
    "Частый вопрос": "Հաճախ տրվող հարց",
    "Чек-лист": "Ստուգացանկ",
    "Чек-лист перед отпуском": "Ստուգացանկ արձակուրդից առաջ",
    "Чек-листы и планы": "Ստուգացանկեր և պլաններ",
    "Чёрный фон, светлый текст и один акцент": "Սև ֆոն, բաց տեքստ և մեկ շեշտ",
    "Честно": "Անկեղծ",
    "Честно и без прикрас": "Անկեղծ և առանց զարդարանքի",
    "Читаем тему": "Կարդում ենք թեման",
    "Что запомнить": "Ինչ հիշել",
    "Что поможет": "Ինչը կօգնի",
    "Шаг {0}": "Քայլ {0}",
    "Шаги с галочками и полоса прогресса": "Նշված քայլեր և առաջընթացի գիծ",
    "Шпаргалки и личные советы": "Հուշաթերթիկներ և անձնական խորհուրդներ",
    "Экспертные посты и цифры": "Փորձագիտական գրառումներ և թվեր",
    "Этот вариант пока недоступен": "Այս տարբերակը դեռ հասանելի չէ",
    "Этот слайд больше нельзя изменить.": "Այս սլայդն այլևս հնարավոր չէ փոխել։",
    "Этот слайд нельзя изменить": "Այս սլայդը հնարավոր չէ փոխել"
  },
  "es": {
    "{0} из {1} знаков": "{0} de {1} caracteres",
    "5 ошибок новичка в беге": "5 errores del corredor principiante",
    "А другу отправьте, чтобы тоже не забыл": "Y envíalo a un amigo para que tampoco lo olvide",
    "Без воды и оправданий": "Sin relleno ni excusas",
    "Без паники": "Sin pánico",
    "Белый фон и крупный чёрный шрифт": "Fondo blanco y letra negra grande",
    "Бот уже прислал карусель с текстом поста в чат, в отдельную тему. Текст правится прямо на слайде, без новой генерации.": "El bot ya envió el carrusel con el texto de la publicación al chat, en un tema aparte. El texto se edita en la propia diapositiva, sin nueva generación.",
    "Ваш ход": "Tu turno",
    "Ваши фото и текст на плашке": "Tus fotos y texto sobre un panel",
    "Вдохновляющий": "Inspirador",
    "ВКонтакте и Telegram": "VK y Telegram",
    "Все оформления": "Todos los diseños",
    "встанут на слайды по порядку": "irán en las diapositivas en orden",
    "Выберите одно простое действие и сделайте его в ближайшие сутки.": "Elige una acción sencilla y hazla en las próximas 24 horas.",
    "Гардероб": "Armario",
    "Главная ошибка": "El error principal",
    "Дерзкий": "Atrevido",
    "Для старта": "Para empezar",
    "До {0} фото, {1}": "Hasta {0} fotos, {1}",
    "Журнал": "Revista",
    "за карусель": "por carrusel",
    "Завтраки": "Desayunos",
    "Заголовок слайда": "Título de la diapositiva",
    "Загружаем фото": "Subiendo fotos",
    "Задайте их в комментариях, ответим": "Pregunta en los comentarios, responderemos",
    "Заметки": "Notas",
    "Запишите цель на видном месте и отмечайте каждый день, когда сделали шаг.": "Escribe tu objetivo en un lugar visible y marca cada día que des un paso.",
    "Заряжает начать": "Te anima a empezar",
    "И отправьте другу, которому это пригодится": "Y envíalo a un amigo al que le sirva",
    "Изменить стиль": "Cambiar estilo",
    "Изменить текст": "Editar texto",
    "Изменить тему": "Cambiar el tema",
    "Иллюстрации готовы": "Ilustraciones listas",
    "Искать среди {0} {1}": "Buscar entre {0} {1}",
    "Истории": "Historias",
    "Истории с продолжением": "Historias por entregas",
    "Каждый шаг считается": "Cada paso cuenta",
    "Как другу за кофе": "Como a un amigo con un café",
    "Как мы открыли кофейню с нуля": "Cómo abrimos una cafetería desde cero",
    "Как понять, что получается": "Cómo saber que funciona",
    "карусель": "carrusel",
    "Карусель готова": "Carrusel listo",
    "Карусель для поста": "Carrusel para publicación",
    "карусель не создана": "el carrusel no se creó",
    "Коротко": "Breve",
    "Коротко и по делу": "Breve y al grano",
    "Коротко о главном": "Lo esencial en breve",
    "Крупная цитата, портрет и рассказ от первого лица": "Cita grande, retrato y relato en primera persona",
    "Лаконичный": "Conciso",
    "Легко и с улыбкой": "Ligero y con una sonrisa",
    "Лист в линейку и выделение маркером": "Hoja rayada y subrayado con marcador",
    "Листайте": "Desliza",
    "Листайте, тут всё по делу": "Desliza, aquí todo va al grano",
    "Личные истории и отзывы": "Historias personales y reseñas",
    "Минимал": "Minimal",
    "Мифы о сне": "Mitos sobre el sueño",
    "Мифы о сне, в которые пора перестать верить": "Mitos sobre el sueño en los que hay que dejar de creer",
    "Мнения, истории и треды": "Opiniones, historias e hilos",
    "Можно без темы: текст по фото": "Sin tema: texto a partir de las fotos",
    "Можно вставить готовый текст": "Puedes pegar un texto listo",
    "Можно уйти с экрана: бот напишет, когда карусель будет готова.": "Puedes salir de la pantalla: el bot te escribirá cuando el carrusel esté listo.",
    "на слайдах": "en las diapositivas",
    "Напишите тему от {0} знаков или добавьте фото": "Escribe un tema de {0} caracteres o más o añade fotos",
    "Например: {0}": "Por ejemplo: {0}",
    "Начните сегодня": "Empieza hoy",
    "Не получилось собрать карусель": "No se pudo montar el carrusel",
    "Неделя полезных завтраков": "Una semana de desayunos saludables",
    "Несколько кадров из моей недели": "Unas fotos de mi semana",
    "Ну что, узнали себя?": "¿Y bien, te reconoces?",
    "О чём пост": "De qué trata la publicación",
    "О чём пост?": "¿De qué trata la publicación?",
    "Обзоры, подборки и мода": "Reseñas, recopilaciones y moda",
    "Окружение, которое поддерживает, и понятный план на неделю вперёд.": "Un entorno que apoya y un plan claro para la semana.",
    "Осенний гардероб: вещи на весь сезон": "Armario de otoño: prendas para toda la temporada",
    "Остались вопросы?": "¿Te quedan dudas?",
    "Отметьте друга, который так делает": "Etiqueta a un amigo que hace esto",
    "Ошибки в беге": "Errores al correr",
    "Панорама": "Panorama",
    "Первый шаг уже сделан": "El primer paso ya está dado",
    "Перед отпуском": "Antes de las vacaciones",
    "Перерисовываем слайд…": "Redibujando la diapositiva…",
    "Пишем подпись и хештеги": "Escribiendo el texto y los hashtags",
    "Пишем текст слайдов": "Escribiendo el texto de las diapositivas",
    "по одному на слайд, по кругу": "una por diapositiva, en bucle",
    "Подписывайтесь: дальше больше пользы": "Síguenos: habrá más contenido útil",
    "Подпись готова": "Texto listo",
    "Подтвердите права на фото": "Confirma los derechos sobre las fotos",
    "Подтверждаю право использовать загружаемые фото": "Confirmo el derecho a usar las fotos que subo",
    "Подходит для": "Ideal para",
    "Полезное": "Útil",
    "Пост-скриншот": "Captura de publicación",
    "Почему это важно": "Por qué importa",
    "Пошаговые инструкции": "Instrucciones paso a paso",
    "Права на свои фото": "Derechos sobre tus fotos",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "La edición no está confirmada. Sigue comprobando la misma solicitud.",
    "Предпросмотр слайдов": "Vista previa de diapositivas",
    "Предыдущий слайд": "Diapositiva anterior",
    "Пригодилось?": "¿Te sirvió?",
    "Пригодится": "Te servirá",
    "Проверьте текст слайда: сервер его не принял.": "Revisa el texto de la diapositiva: el servidor no lo aceptó.",
    "Простой приём": "Un truco sencillo",
    "пункт": "punto",
    "пункта": "puntos",
    "пунктов": "puntos",
    "Путешествия, события и товары": "Viajes, eventos y productos",
    "Пытаться сделать всё сразу. Маленький шаг каждый день лучше рывка раз в месяц.": "Intentar hacerlo todo a la vez. Un pequeño paso cada día es mejor que un sprint al mes.",
    "Разберёмся, что даёт эта тема и почему о ней стоит знать уже сегодня.": "Veamos qué aporta este tema y por qué conviene conocerlo ya hoy.",
    "Разбор": "Análisis",
    "Разбор по пунктам": "Análisis punto por punto",
    "Регулярность важнее идеальности. Начните с малого и не бросайте.": "La constancia importa más que la perfección. Empieza poco a poco y no lo dejes.",
    "Рисуем иллюстрации": "Dibujando ilustraciones",
    "С фото": "Con fotos",
    "С чего начать": "Por dónde empezar",
    "С юмором": "Con humor",
    "Самое важное": "Lo más importante",
    "Свои фото": "Tus fotos",
    "Своя кофейня": "Cafetería propia",
    "Сколько ждать результата? Первые перемены обычно видны через две-три недели.": "¿Cuánto esperar resultados? Los primeros cambios suelen verse en dos o tres semanas.",
    "Сколько слайдов": "Cuántas diapositivas",
    "слайд": "diapositiva",
    "Слайд {0} из {1}": "Diapositiva {0} de {1}",
    "Слайд как пост в соцсети: аватар, имя, текст": "Diapositiva como publicación social: avatar, nombre, texto",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "La diapositiva ya cambió. Actualizamos el resultado: revisa el texto y guarda de nuevo.",
    "слайда": "diapositivas",
    "слайдов": "diapositivas",
    "Слайды ещё загружаются": "Las diapositivas aún se están cargando",
    "Слайды собраны": "Diapositivas montadas",
    "Следующий слайд": "Diapositiva siguiente",
    "Смело и с вызовом": "Valiente y desafiante",
    "Смотрим ваши фото": "Revisando tus fotos",
    "Собираем карусель": "Montando el carrusel",
    "Собираем слайды": "Montando las diapositivas",
    "Советы и гайды": "Consejos y guías",
    "Создать карусель": "Crear carrusel",
    "Создать карусель · {0} C": "Crear carrusel · {0} C",
    "Сохраните": "Guárdalo",
    "Сохраните и отправьте тому, кто тоже начинает": "Guárdalo y envíalo a alguien que también empieza",
    "Сохраните и поделитесь": "Guarda y comparte",
    "Сохраните и проверьте на себе": "Guárdalo y pruébalo tú mismo",
    "Сохраните пост и вернитесь к нему, когда нужна поддержка": "Guarda la publicación y vuelve a ella cuando necesites apoyo",
    "Сохраните пост и начните завтра": "Guarda la publicación y empieza mañana",
    "Сохраните пост и поделитесь им с друзьями": "Guarda la publicación y compártela con amigos",
    "Сохраните разбор": "Guarda el análisis",
    "Сохраните, пока не забыли": "Guárdalo antes de que se te olvide",
    "Сохраните, пригодится": "Guárdalo, te servirá",
    "Сохраните, чтобы не потерять": "Guárdalo para no perderlo",
    "Списки": "Listas",
    "Спокойно, это лечится": "Tranquilo, tiene solución",
    "Сравнивайте себя с собой месяц назад, а не с другими.": "Compárate contigo hace un mes, no con los demás.",
    "стилей": "estilos",
    "Стили": "Estilos",
    "Стиль «{0}»": "Estilo «{0}»",
    "Стиль поста": "Estilo de la publicación",
    "Стиль шаблона": "Estilo de la plantilla",
    "стиля": "estilo",
    "Текст выделен: скопируйте его вручную": "El texto está seleccionado: cópialo a mano",
    "Текст длиннее {0} знаков": "El texto tiene más de {0} caracteres",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "El texto no cabe en la diapositiva. Acorta el título o el texto.",
    "Текст по вашим фото": "Texto a partir de tus fotos",
    "Текст слайда": "Texto de la diapositiva",
    "Тема не прошла проверку": "El tema no pasó la revisión",
    "Тема разобрана": "Tema analizado",
    "Тёмный": "Oscuro",
    "Только проверенные факты": "Solo datos comprobados",
    "Тон": "Tono",
    "тон {0}": "tono {0}",
    "Тут откроется тема чата, куда бот прислал карусель": "Aquí se abrirá el tema del chat donde el bot envió el carrusel",
    "У вас получится": "Lo vas a lograr",
    "У каждого слайда свой цвет и крупная цифра": "Cada diapositiva con su color y un número grande",
    "Узнали себя? Листайте": "¿Te reconoces? Desliza",
    "Факты и цифры без воды": "Datos y cifras sin relleno",
    "Фон и линия перетекают со слайда на слайд": "El fondo y la línea fluyen de una diapositiva a otra",
    "Фото и антиква, подписи как в журнале": "Fotos y tipografía serif, pies como en revista",
    "Фото на весь слайд": "Foto a toda la diapositiva",
    "Фото разобраны": "Fotos revisadas",
    "Хватит откладывать": "Deja de posponerlo",
    "Цветные блоки": "Bloques de color",
    "Цена": "Precio",
    "Цитата и история": "Cita e historia",
    "Частый вопрос": "Pregunta frecuente",
    "Чек-лист": "Lista de control",
    "Чек-лист перед отпуском": "Lista antes de las vacaciones",
    "Чек-листы и планы": "Listas de control y planes",
    "Чёрный фон, светлый текст и один акцент": "Fondo negro, texto claro y un acento",
    "Честно": "Con sinceridad",
    "Честно и без прикрас": "Sincero y sin adornos",
    "Читаем тему": "Leyendo el tema",
    "Что запомнить": "Qué recordar",
    "Что поможет": "Qué ayuda",
    "Шаг {0}": "Paso {0}",
    "Шаги с галочками и полоса прогресса": "Pasos con casillas y barra de progreso",
    "Шпаргалки и личные советы": "Chuletas y consejos personales",
    "Экспертные посты и цифры": "Publicaciones expertas y cifras",
    "Этот вариант пока недоступен": "Esta opción aún no está disponible",
    "Этот слайд больше нельзя изменить.": "Esta diapositiva ya no se puede editar.",
    "Этот слайд нельзя изменить": "Esta diapositiva no se puede editar"
  },
  "de": {
    "{0} из {1} знаков": "{0} von {1} Zeichen",
    "5 ошибок новичка в беге": "5 Anfängerfehler beim Laufen",
    "А другу отправьте, чтобы тоже не забыл": "Und schicken Sie es einem Freund, damit er es auch nicht vergisst",
    "Без воды и оправданий": "Ohne Füllstoff und Ausreden",
    "Без паники": "Keine Panik",
    "Белый фон и крупный чёрный шрифт": "Weißer Hintergrund und große schwarze Schrift",
    "Бот уже прислал карусель с текстом поста в чат, в отдельную тему. Текст правится прямо на слайде, без новой генерации.": "Der Bot hat das Karussell mit dem Posttext bereits in den Chat geschickt, in ein eigenes Thema. Der Text wird direkt auf der Folie bearbeitet, ohne neue Generierung.",
    "Ваш ход": "Sie sind dran",
    "Ваши фото и текст на плашке": "Ihre Fotos und Text auf einer Fläche",
    "Вдохновляющий": "Inspirierend",
    "ВКонтакте и Telegram": "VK und Telegram",
    "Все оформления": "Alle Designs",
    "встанут на слайды по порядку": "kommen der Reihe nach auf die Folien",
    "Выберите одно простое действие и сделайте его в ближайшие сутки.": "Wählen Sie eine einfache Handlung und erledigen Sie sie innerhalb eines Tages.",
    "Гардероб": "Garderobe",
    "Главная ошибка": "Der Hauptfehler",
    "Дерзкий": "Frech",
    "Для старта": "Zum Start",
    "До {0} фото, {1}": "Bis zu {0} Fotos, {1}",
    "Журнал": "Magazin",
    "за карусель": "pro Karussell",
    "Завтраки": "Frühstücke",
    "Заголовок слайда": "Folientitel",
    "Загружаем фото": "Fotos werden hochgeladen",
    "Задайте их в комментариях, ответим": "Fragen Sie in den Kommentaren, wir antworten",
    "Заметки": "Notizen",
    "Запишите цель на видном месте и отмечайте каждый день, когда сделали шаг.": "Schreiben Sie das Ziel gut sichtbar auf und markieren Sie jeden Tag mit einem Schritt.",
    "Заряжает начать": "Macht Lust anzufangen",
    "И отправьте другу, которому это пригодится": "Und schicken Sie es einem Freund, dem es hilft",
    "Изменить стиль": "Stil ändern",
    "Изменить текст": "Text bearbeiten",
    "Изменить тему": "Thema ändern",
    "Иллюстрации готовы": "Illustrationen fertig",
    "Искать среди {0} {1}": "Unter {0} {1} suchen",
    "Истории": "Geschichten",
    "Истории с продолжением": "Fortsetzungsgeschichten",
    "Каждый шаг считается": "Jeder Schritt zählt",
    "Как другу за кофе": "Wie einem Freund beim Kaffee",
    "Как мы открыли кофейню с нуля": "Wie wir ein Café von null eröffnet haben",
    "Как понять, что получается": "Woran man merkt, dass es klappt",
    "карусель": "Karussell",
    "Карусель готова": "Karussell fertig",
    "Карусель для поста": "Karussell für einen Post",
    "карусель не создана": "das Karussell wurde nicht erstellt",
    "Коротко": "Kurz",
    "Коротко и по делу": "Kurz und auf den Punkt",
    "Коротко о главном": "Das Wichtigste in Kürze",
    "Крупная цитата, портрет и рассказ от первого лица": "Großes Zitat, Porträt und Erzählung in der Ich-Form",
    "Лаконичный": "Knapp",
    "Легко и с улыбкой": "Leicht und mit einem Lächeln",
    "Лист в линейку и выделение маркером": "Liniertes Blatt und Textmarker",
    "Листайте": "Wischen",
    "Листайте, тут всё по делу": "Wischen, hier ist alles auf den Punkt",
    "Личные истории и отзывы": "Persönliche Geschichten und Bewertungen",
    "Минимал": "Minimal",
    "Мифы о сне": "Schlafmythen",
    "Мифы о сне, в которые пора перестать верить": "Schlafmythen, an die man nicht mehr glauben sollte",
    "Мнения, истории и треды": "Meinungen, Geschichten und Threads",
    "Можно без темы: текст по фото": "Auch ohne Thema: Text nach den Fotos",
    "Можно вставить готовый текст": "Fertigen Text einfügen ist möglich",
    "Можно уйти с экрана: бот напишет, когда карусель будет готова.": "Sie können den Bildschirm verlassen: Der Bot schreibt, wenn das Karussell fertig ist.",
    "на слайдах": "auf den Folien",
    "Напишите тему от {0} знаков или добавьте фото": "Schreiben Sie ein Thema ab {0} Zeichen oder fügen Sie Fotos hinzu",
    "Например: {0}": "Zum Beispiel: {0}",
    "Начните сегодня": "Fangen Sie heute an",
    "Не получилось собрать карусель": "Das Karussell konnte nicht erstellt werden",
    "Неделя полезных завтраков": "Eine Woche gesunder Frühstücke",
    "Несколько кадров из моей недели": "Ein paar Bilder aus meiner Woche",
    "Ну что, узнали себя?": "Na, wiedererkannt?",
    "О чём пост": "Worum es im Post geht",
    "О чём пост?": "Worum geht es im Post?",
    "Обзоры, подборки и мода": "Reviews, Sammlungen und Mode",
    "Окружение, которое поддерживает, и понятный план на неделю вперёд.": "Ein unterstützendes Umfeld und ein klarer Plan für die nächste Woche.",
    "Осенний гардероб: вещи на весь сезон": "Herbstgarderobe: Teile für die ganze Saison",
    "Остались вопросы?": "Noch Fragen?",
    "Отметьте друга, который так делает": "Markieren Sie einen Freund, der das macht",
    "Ошибки в беге": "Lauffehler",
    "Панорама": "Panorama",
    "Первый шаг уже сделан": "Der erste Schritt ist getan",
    "Перед отпуском": "Vor dem Urlaub",
    "Перерисовываем слайд…": "Folie wird neu gezeichnet…",
    "Пишем подпись и хештеги": "Wir schreiben Bildtext und Hashtags",
    "Пишем текст слайдов": "Wir schreiben den Folientext",
    "по одному на слайд, по кругу": "eins pro Folie, im Kreis",
    "Подписывайтесь: дальше больше пользы": "Folgen Sie uns: Es kommt noch mehr Nützliches",
    "Подпись готова": "Bildtext fertig",
    "Подтвердите права на фото": "Bestätigen Sie die Rechte an den Fotos",
    "Подтверждаю право использовать загружаемые фото": "Ich bestätige das Recht, die hochgeladenen Fotos zu nutzen",
    "Подходит для": "Passt zu",
    "Полезное": "Nützlich",
    "Пост-скриншот": "Post-Screenshot",
    "Почему это важно": "Warum das wichtig ist",
    "Пошаговые инструкции": "Schritt-für-Schritt-Anleitungen",
    "Права на свои фото": "Rechte an eigenen Fotos",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "Die Änderung ist nicht bestätigt. Prüfen Sie dieselbe Anfrage weiter.",
    "Предпросмотр слайдов": "Folienvorschau",
    "Предыдущий слайд": "Vorherige Folie",
    "Пригодилось?": "War es hilfreich?",
    "Пригодится": "Das hilft später",
    "Проверьте текст слайда: сервер его не принял.": "Prüfen Sie den Folientext: Der Server hat ihn nicht angenommen.",
    "Простой приём": "Ein einfacher Trick",
    "пункт": "Punkt",
    "пункта": "Punkte",
    "пунктов": "Punkte",
    "Путешествия, события и товары": "Reisen, Events und Produkte",
    "Пытаться сделать всё сразу. Маленький шаг каждый день лучше рывка раз в месяц.": "Alles auf einmal machen wollen. Ein kleiner Schritt jeden Tag ist besser als ein Kraftakt einmal im Monat.",
    "Разберёмся, что даёт эта тема и почему о ней стоит знать уже сегодня.": "Schauen wir, was dieses Thema bringt und warum man schon heute davon wissen sollte.",
    "Разбор": "Analyse",
    "Разбор по пунктам": "Analyse Punkt für Punkt",
    "Регулярность важнее идеальности. Начните с малого и не бросайте.": "Regelmäßigkeit ist wichtiger als Perfektion. Klein anfangen und dranbleiben.",
    "Рисуем иллюстрации": "Wir zeichnen Illustrationen",
    "С фото": "Mit Fotos",
    "С чего начать": "Womit anfangen",
    "С юмором": "Mit Humor",
    "Самое важное": "Das Wichtigste",
    "Свои фото": "Eigene Fotos",
    "Своя кофейня": "Eigenes Café",
    "Сколько ждать результата? Первые перемены обычно видны через две-три недели.": "Wie lange bis zum Ergebnis? Erste Veränderungen zeigen sich meist nach zwei bis drei Wochen.",
    "Сколько слайдов": "Wie viele Folien",
    "слайд": "Folie",
    "Слайд {0} из {1}": "Folie {0} von {1}",
    "Слайд как пост в соцсети: аватар, имя, текст": "Folie als Social-Post: Avatar, Name, Text",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "Die Folie wurde bereits geändert. Wir haben das Ergebnis aktualisiert — prüfen Sie den Text und speichern Sie erneut.",
    "слайда": "Folien",
    "слайдов": "Folien",
    "Слайды ещё загружаются": "Die Folien werden noch geladen",
    "Слайды собраны": "Folien zusammengestellt",
    "Следующий слайд": "Nächste Folie",
    "Смело и с вызовом": "Mutig und herausfordernd",
    "Смотрим ваши фото": "Wir sehen uns Ihre Fotos an",
    "Собираем карусель": "Wir bauen das Karussell",
    "Собираем слайды": "Folien werden erstellt",
    "Советы и гайды": "Tipps und Anleitungen",
    "Создать карусель": "Karussell erstellen",
    "Создать карусель · {0} C": "Karussell erstellen · {0} C",
    "Сохраните": "Speichern",
    "Сохраните и отправьте тому, кто тоже начинает": "Speichern und an jemanden schicken, der auch anfängt",
    "Сохраните и поделитесь": "Speichern und teilen",
    "Сохраните и проверьте на себе": "Speichern und selbst ausprobieren",
    "Сохраните пост и вернитесь к нему, когда нужна поддержка": "Speichern Sie den Post und kehren Sie zurück, wenn Sie Unterstützung brauchen",
    "Сохраните пост и начните завтра": "Speichern Sie den Post und fangen Sie morgen an",
    "Сохраните пост и поделитесь им с друзьями": "Speichern Sie den Post und teilen Sie ihn mit Freunden",
    "Сохраните разбор": "Analyse speichern",
    "Сохраните, пока не забыли": "Speichern, bevor Sie es vergessen",
    "Сохраните, пригодится": "Speichern, das hilft später",
    "Сохраните, чтобы не потерять": "Speichern, um es nicht zu verlieren",
    "Списки": "Listen",
    "Спокойно, это лечится": "Ruhig, das ist heilbar",
    "Сравнивайте себя с собой месяц назад, а не с другими.": "Vergleichen Sie sich mit sich selbst vor einem Monat, nicht mit anderen.",
    "стилей": "Stilen",
    "Стили": "Stile",
    "Стиль «{0}»": "Stil „{0}“",
    "Стиль поста": "Post-Stil",
    "Стиль шаблона": "Vorlagenstil",
    "стиля": "Stil",
    "Текст выделен: скопируйте его вручную": "Der Text ist markiert: Kopieren Sie ihn manuell",
    "Текст длиннее {0} знаков": "Der Text ist länger als {0} Zeichen",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "Der Text passt nicht auf die Folie. Kürzen Sie die Überschrift oder den Text.",
    "Текст по вашим фото": "Text nach Ihren Fotos",
    "Текст слайда": "Folientext",
    "Тема не прошла проверку": "Das Thema hat die Prüfung nicht bestanden",
    "Тема разобрана": "Thema ausgewertet",
    "Тёмный": "Dunkel",
    "Только проверенные факты": "Nur geprüfte Fakten",
    "Тон": "Ton",
    "тон {0}": "Ton {0}",
    "Тут откроется тема чата, куда бот прислал карусель": "Hier öffnet sich das Chat-Thema, in das der Bot das Karussell geschickt hat",
    "У вас получится": "Sie schaffen das",
    "У каждого слайда свой цвет и крупная цифра": "Jede Folie mit eigener Farbe und großer Zahl",
    "Узнали себя? Листайте": "Wiedererkannt? Wischen",
    "Факты и цифры без воды": "Fakten und Zahlen ohne Füllstoff",
    "Фон и линия перетекают со слайда на слайд": "Hintergrund und Linie fließen von Folie zu Folie",
    "Фото и антиква, подписи как в журнале": "Fotos und Antiqua, Bildunterschriften wie im Magazin",
    "Фото на весь слайд": "Foto über die ganze Folie",
    "Фото разобраны": "Fotos ausgewertet",
    "Хватит откладывать": "Schluss mit Aufschieben",
    "Цветные блоки": "Farbblöcke",
    "Цена": "Preis",
    "Цитата и история": "Zitat und Geschichte",
    "Частый вопрос": "Häufige Frage",
    "Чек-лист": "Checkliste",
    "Чек-лист перед отпуском": "Checkliste vor dem Urlaub",
    "Чек-листы и планы": "Checklisten und Pläne",
    "Чёрный фон, светлый текст и один акцент": "Schwarzer Hintergrund, heller Text und ein Akzent",
    "Честно": "Ehrlich",
    "Честно и без прикрас": "Ehrlich und ungeschönt",
    "Читаем тему": "Wir lesen das Thema",
    "Что запомнить": "Was man sich merken sollte",
    "Что поможет": "Was hilft",
    "Шаг {0}": "Schritt {0}",
    "Шаги с галочками и полоса прогресса": "Schritte mit Häkchen und Fortschrittsbalken",
    "Шпаргалки и личные советы": "Spickzettel und persönliche Tipps",
    "Экспертные посты и цифры": "Expertenposts und Zahlen",
    "Этот вариант пока недоступен": "Diese Variante ist noch nicht verfügbar",
    "Этот слайд больше нельзя изменить.": "Diese Folie kann nicht mehr geändert werden.",
    "Этот слайд нельзя изменить": "Diese Folie kann nicht geändert werden"
  },
  "fr": {
    "{0} из {1} знаков": "{0} sur {1} caractères",
    "5 ошибок новичка в беге": "5 erreurs du coureur débutant",
    "А другу отправьте, чтобы тоже не забыл": "Et envoyez-le à un ami pour qu’il n’oublie pas non plus",
    "Без воды и оправданий": "Sans blabla ni excuses",
    "Без паники": "Pas de panique",
    "Белый фон и крупный чёрный шрифт": "Fond blanc et grande police noire",
    "Бот уже прислал карусель с текстом поста в чат, в отдельную тему. Текст правится прямо на слайде, без новой генерации.": "Le bot a déjà envoyé le carrousel avec le texte du post dans le chat, dans un sujet à part. Le texte se modifie directement sur la diapositive, sans nouvelle génération.",
    "Ваш ход": "À vous de jouer",
    "Ваши фото и текст на плашке": "Vos photos et un texte sur un bandeau",
    "Вдохновляющий": "Inspirant",
    "ВКонтакте и Telegram": "VK et Telegram",
    "Все оформления": "Tous les styles",
    "встанут на слайды по порядку": "iront sur les diapositives dans l’ordre",
    "Выберите одно простое действие и сделайте его в ближайшие сутки.": "Choisissez une action simple et faites-la dans les prochaines 24 heures.",
    "Гардероб": "Garde-robe",
    "Главная ошибка": "L’erreur principale",
    "Дерзкий": "Audacieux",
    "Для старта": "Pour démarrer",
    "До {0} фото, {1}": "Jusqu’à {0} photos, {1}",
    "Журнал": "Magazine",
    "за карусель": "par carrousel",
    "Завтраки": "Petits-déjeuners",
    "Заголовок слайда": "Titre de la diapositive",
    "Загружаем фото": "Envoi des photos",
    "Задайте их в комментариях, ответим": "Posez-les en commentaire, nous répondrons",
    "Заметки": "Notes",
    "Запишите цель на видном месте и отмечайте каждый день, когда сделали шаг.": "Écrivez votre objectif bien en vue et cochez chaque jour où vous avez avancé.",
    "Заряжает начать": "Donne envie de commencer",
    "И отправьте другу, которому это пригодится": "Et envoyez-le à un ami à qui ça servira",
    "Изменить стиль": "Changer de style",
    "Изменить текст": "Modifier le texte",
    "Изменить тему": "Changer le sujet",
    "Иллюстрации готовы": "Illustrations prêtes",
    "Искать среди {0} {1}": "Rechercher parmi {0} {1}",
    "Истории": "Histoires",
    "Истории с продолжением": "Histoires à suivre",
    "Каждый шаг считается": "Chaque pas compte",
    "Как другу за кофе": "Comme à un ami autour d’un café",
    "Как мы открыли кофейню с нуля": "Comment nous avons ouvert un café à partir de rien",
    "Как понять, что получается": "Comment savoir que ça marche",
    "карусель": "carrousel",
    "Карусель готова": "Carrousel prêt",
    "Карусель для поста": "Carrousel pour un post",
    "карусель не создана": "le carrousel n’a pas été créé",
    "Коротко": "Court",
    "Коротко и по делу": "Court et précis",
    "Коротко о главном": "L’essentiel en bref",
    "Крупная цитата, портрет и рассказ от первого лица": "Grande citation, portrait et récit à la première personne",
    "Лаконичный": "Concis",
    "Легко и с улыбкой": "Léger et avec le sourire",
    "Лист в линейку и выделение маркером": "Feuille lignée et surligneur",
    "Листайте": "Faites défiler",
    "Листайте, тут всё по делу": "Faites défiler, tout est utile",
    "Личные истории и отзывы": "Histoires personnelles et avis",
    "Минимал": "Minimal",
    "Мифы о сне": "Mythes sur le sommeil",
    "Мифы о сне, в которые пора перестать верить": "Mythes sur le sommeil auxquels il faut cesser de croire",
    "Мнения, истории и треды": "Opinions, histoires et fils",
    "Можно без темы: текст по фото": "Sans sujet : texte d’après les photos",
    "Можно вставить готовый текст": "Vous pouvez coller un texte prêt",
    "Можно уйти с экрана: бот напишет, когда карусель будет готова.": "Vous pouvez quitter l’écran : le bot vous écrira quand le carrousel sera prêt.",
    "на слайдах": "sur les diapositives",
    "Напишите тему от {0} знаков или добавьте фото": "Écrivez un sujet de {0} caractères ou plus, ou ajoutez des photos",
    "Например: {0}": "Par exemple : {0}",
    "Начните сегодня": "Commencez aujourd’hui",
    "Не получилось собрать карусель": "Impossible d’assembler le carrousel",
    "Неделя полезных завтраков": "Une semaine de petits-déjeuners sains",
    "Несколько кадров из моей недели": "Quelques photos de ma semaine",
    "Ну что, узнали себя?": "Alors, vous vous reconnaissez ?",
    "О чём пост": "Sujet du post",
    "О чём пост?": "De quoi parle le post ?",
    "Обзоры, подборки и мода": "Critiques, sélections et mode",
    "Окружение, которое поддерживает, и понятный план на неделю вперёд.": "Un entourage qui soutient et un plan clair pour la semaine à venir.",
    "Осенний гардероб: вещи на весь сезон": "Garde-robe d’automne : des pièces pour toute la saison",
    "Остались вопросы?": "Des questions ?",
    "Отметьте друга, который так делает": "Identifiez un ami qui fait ça",
    "Ошибки в беге": "Erreurs en course",
    "Панорама": "Panorama",
    "Первый шаг уже сделан": "Le premier pas est fait",
    "Перед отпуском": "Avant les vacances",
    "Перерисовываем слайд…": "Redessin de la diapositive…",
    "Пишем подпись и хештеги": "Nous écrivons la légende et les hashtags",
    "Пишем текст слайдов": "Nous écrivons le texte des diapositives",
    "по одному на слайд, по кругу": "une par diapositive, en boucle",
    "Подписывайтесь: дальше больше пользы": "Abonnez-vous : plus de contenu utile arrive",
    "Подпись готова": "Légende prête",
    "Подтвердите права на фото": "Confirmez les droits sur les photos",
    "Подтверждаю право использовать загружаемые фото": "Je confirme avoir le droit d’utiliser les photos envoyées",
    "Подходит для": "Convient pour",
    "Полезное": "Utile",
    "Пост-скриншот": "Capture de post",
    "Почему это важно": "Pourquoi c’est important",
    "Пошаговые инструкции": "Instructions pas à pas",
    "Права на свои фото": "Droits sur vos photos",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "La modification n’est pas confirmée. Poursuivez la vérification de la même demande.",
    "Предпросмотр слайдов": "Aperçu des diapositives",
    "Предыдущий слайд": "Diapositive précédente",
    "Пригодилось?": "C’était utile ?",
    "Пригодится": "Ça servira",
    "Проверьте текст слайда: сервер его не принял.": "Vérifiez le texte de la diapositive : le serveur ne l’a pas accepté.",
    "Простой приём": "Une astuce simple",
    "пункт": "point",
    "пункта": "points",
    "пунктов": "points",
    "Путешествия, события и товары": "Voyages, événements et produits",
    "Пытаться сделать всё сразу. Маленький шаг каждый день лучше рывка раз в месяц.": "Vouloir tout faire d’un coup. Un petit pas chaque jour vaut mieux qu’un sprint une fois par mois.",
    "Разберёмся, что даёт эта тема и почему о ней стоит знать уже сегодня.": "Voyons ce que ce sujet apporte et pourquoi le connaître dès aujourd’hui.",
    "Разбор": "Décryptage",
    "Разбор по пунктам": "Décryptage point par point",
    "Регулярность важнее идеальности. Начните с малого и не бросайте.": "La régularité compte plus que la perfection. Commencez petit et n’abandonnez pas.",
    "Рисуем иллюстрации": "Nous dessinons les illustrations",
    "С фото": "Avec photos",
    "С чего начать": "Par où commencer",
    "С юмором": "Avec humour",
    "Самое важное": "L’essentiel",
    "Свои фото": "Vos photos",
    "Своя кофейня": "Son propre café",
    "Сколько ждать результата? Первые перемены обычно видны через две-три недели.": "Combien de temps avant des résultats ? Les premiers changements se voient en général en deux ou trois semaines.",
    "Сколько слайдов": "Combien de diapositives",
    "слайд": "diapositive",
    "Слайд {0} из {1}": "Diapositive {0} sur {1}",
    "Слайд как пост в соцсети: аватар, имя, текст": "Diapositive façon post social : avatar, nom, texte",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "La diapositive a déjà été modifiée. Nous avons actualisé le résultat — vérifiez le texte et enregistrez à nouveau.",
    "слайда": "diapositives",
    "слайдов": "diapositives",
    "Слайды ещё загружаются": "Les diapositives sont encore en chargement",
    "Слайды собраны": "Diapositives assemblées",
    "Следующий слайд": "Diapositive suivante",
    "Смело и с вызовом": "Osé et provocant",
    "Смотрим ваши фото": "Nous regardons vos photos",
    "Собираем карусель": "Nous assemblons le carrousel",
    "Собираем слайды": "Assemblage des diapositives",
    "Советы и гайды": "Conseils et guides",
    "Создать карусель": "Créer le carrousel",
    "Создать карусель · {0} C": "Créer le carrousel · {0} C",
    "Сохраните": "Enregistrez",
    "Сохраните и отправьте тому, кто тоже начинает": "Enregistrez et envoyez-le à quelqu’un qui débute aussi",
    "Сохраните и поделитесь": "Enregistrez et partagez",
    "Сохраните и проверьте на себе": "Enregistrez et testez par vous-même",
    "Сохраните пост и вернитесь к нему, когда нужна поддержка": "Enregistrez le post et revenez-y quand vous avez besoin de soutien",
    "Сохраните пост и начните завтра": "Enregistrez le post et commencez demain",
    "Сохраните пост и поделитесь им с друзьями": "Enregistrez le post et partagez-le avec vos amis",
    "Сохраните разбор": "Enregistrez le décryptage",
    "Сохраните, пока не забыли": "Enregistrez-le avant d’oublier",
    "Сохраните, пригодится": "Enregistrez-le, ça servira",
    "Сохраните, чтобы не потерять": "Enregistrez-le pour ne pas le perdre",
    "Списки": "Listes",
    "Спокойно, это лечится": "Du calme, ça se soigne",
    "Сравнивайте себя с собой месяц назад, а не с другими.": "Comparez-vous à vous-même il y a un mois, pas aux autres.",
    "стилей": "styles",
    "Стили": "Styles",
    "Стиль «{0}»": "Style « {0} »",
    "Стиль поста": "Style du post",
    "Стиль шаблона": "Style du modèle",
    "стиля": "style",
    "Текст выделен: скопируйте его вручную": "Le texte est sélectionné : copiez-le manuellement",
    "Текст длиннее {0} знаков": "Le texte dépasse {0} caractères",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "Le texte ne tient pas sur la diapositive. Raccourcissez le titre ou le texte.",
    "Текст по вашим фото": "Texte d’après vos photos",
    "Текст слайда": "Texte de la diapositive",
    "Тема не прошла проверку": "Le sujet n’a pas passé la vérification",
    "Тема разобрана": "Sujet analysé",
    "Тёмный": "Sombre",
    "Только проверенные факты": "Uniquement des faits vérifiés",
    "Тон": "Ton",
    "тон {0}": "ton {0}",
    "Тут откроется тема чата, куда бот прислал карусель": "Ici s’ouvrira le sujet du chat où le bot a envoyé le carrousel",
    "У вас получится": "Vous allez y arriver",
    "У каждого слайда свой цвет и крупная цифра": "Chaque diapositive a sa couleur et un grand chiffre",
    "Узнали себя? Листайте": "Vous vous reconnaissez ? Faites défiler",
    "Факты и цифры без воды": "Faits et chiffres, sans blabla",
    "Фон и линия перетекают со слайда на слайд": "Le fond et la ligne coulent d’une diapositive à l’autre",
    "Фото и антиква, подписи как в журнале": "Photos et typo à empattements, légendes façon magazine",
    "Фото на весь слайд": "Photo pleine diapositive",
    "Фото разобраны": "Photos analysées",
    "Хватит откладывать": "Arrêtez de remettre à plus tard",
    "Цветные блоки": "Blocs de couleur",
    "Цена": "Prix",
    "Цитата и история": "Citation et histoire",
    "Частый вопрос": "Question fréquente",
    "Чек-лист": "Check-list",
    "Чек-лист перед отпуском": "Check-list avant les vacances",
    "Чек-листы и планы": "Check-lists et plans",
    "Чёрный фон, светлый текст и один акцент": "Fond noir, texte clair et un accent",
    "Честно": "Franchement",
    "Честно и без прикрас": "Honnête et sans fard",
    "Читаем тему": "Nous lisons le sujet",
    "Что запомнить": "À retenir",
    "Что поможет": "Ce qui aide",
    "Шаг {0}": "Étape {0}",
    "Шаги с галочками и полоса прогресса": "Étapes cochées et barre de progression",
    "Шпаргалки и личные советы": "Antisèches et conseils personnels",
    "Экспертные посты и цифры": "Posts d’expert et chiffres",
    "Этот вариант пока недоступен": "Cette option n’est pas encore disponible",
    "Этот слайд больше нельзя изменить.": "Cette diapositive ne peut plus être modifiée.",
    "Этот слайд нельзя изменить": "Cette diapositive ne peut pas être modifiée"
  },
  "pt": {
    "{0} из {1} знаков": "{0} de {1} caracteres",
    "5 ошибок новичка в беге": "5 erros do corredor iniciante",
    "А другу отправьте, чтобы тоже не забыл": "E envie a um amigo para ele também não esquecer",
    "Без воды и оправданий": "Sem enrolação nem desculpas",
    "Без паники": "Sem pânico",
    "Белый фон и крупный чёрный шрифт": "Fundo branco e fonte preta grande",
    "Бот уже прислал карусель с текстом поста в чат, в отдельную тему. Текст правится прямо на слайде, без новой генерации.": "O bot já enviou o carrossel com o texto do post para o chat, em um tópico separado. O texto é editado direto no slide, sem nova geração.",
    "Ваш ход": "Sua vez",
    "Ваши фото и текст на плашке": "Suas fotos e texto sobre uma faixa",
    "Вдохновляющий": "Inspirador",
    "ВКонтакте и Telegram": "VK e Telegram",
    "Все оформления": "Todos os designs",
    "встанут на слайды по порядку": "entram nos slides em ordem",
    "Выберите одно простое действие и сделайте его в ближайшие сутки.": "Escolha uma ação simples e faça-a nas próximas 24 horas.",
    "Гардероб": "Guarda-roupa",
    "Главная ошибка": "O principal erro",
    "Дерзкий": "Ousado",
    "Для старта": "Para começar",
    "До {0} фото, {1}": "Até {0} fotos, {1}",
    "Журнал": "Revista",
    "за карусель": "por carrossel",
    "Завтраки": "Cafés da manhã",
    "Заголовок слайда": "Título do slide",
    "Загружаем фото": "Enviando fotos",
    "Задайте их в комментариях, ответим": "Pergunte nos comentários, vamos responder",
    "Заметки": "Notas",
    "Запишите цель на видном месте и отмечайте каждый день, когда сделали шаг.": "Escreva a meta num lugar visível e marque cada dia em que deu um passo.",
    "Заряжает начать": "Dá vontade de começar",
    "И отправьте другу, которому это пригодится": "E envie para um amigo que vai precisar",
    "Изменить стиль": "Mudar estilo",
    "Изменить текст": "Editar texto",
    "Изменить тему": "Mudar o tema",
    "Иллюстрации готовы": "Ilustrações prontas",
    "Искать среди {0} {1}": "Pesquisar entre {0} {1}",
    "Истории": "Histórias",
    "Истории с продолжением": "Histórias em capítulos",
    "Каждый шаг считается": "Cada passo conta",
    "Как другу за кофе": "Como a um amigo num café",
    "Как мы открыли кофейню с нуля": "Como abrimos uma cafeteria do zero",
    "Как понять, что получается": "Como saber que está dando certo",
    "карусель": "carrossel",
    "Карусель готова": "Carrossel pronto",
    "Карусель для поста": "Carrossel para post",
    "карусель не создана": "o carrossel não foi criado",
    "Коротко": "Curto",
    "Коротко и по делу": "Curto e direto ao ponto",
    "Коротко о главном": "O essencial em resumo",
    "Крупная цитата, портрет и рассказ от первого лица": "Citação grande, retrato e relato em primeira pessoa",
    "Лаконичный": "Conciso",
    "Легко и с улыбкой": "Leve e com um sorriso",
    "Лист в линейку и выделение маркером": "Folha pautada e marca-texto",
    "Листайте": "Deslize",
    "Листайте, тут всё по делу": "Deslize, aqui é tudo direto ao ponto",
    "Личные истории и отзывы": "Histórias pessoais e depoimentos",
    "Минимал": "Minimal",
    "Мифы о сне": "Mitos sobre o sono",
    "Мифы о сне, в которые пора перестать верить": "Mitos sobre o sono em que é hora de parar de acreditar",
    "Мнения, истории и треды": "Opiniões, histórias e threads",
    "Можно без темы: текст по фото": "Sem tema: texto a partir das fotos",
    "Можно вставить готовый текст": "Pode colar um texto pronto",
    "Можно уйти с экрана: бот напишет, когда карусель будет готова.": "Pode sair da tela: o bot avisa quando o carrossel estiver pronto.",
    "на слайдах": "nos slides",
    "Напишите тему от {0} знаков или добавьте фото": "Escreva um tema com {0}+ caracteres ou adicione fotos",
    "Например: {0}": "Por exemplo: {0}",
    "Начните сегодня": "Comece hoje",
    "Не получилось собрать карусель": "Não foi possível montar o carrossel",
    "Неделя полезных завтраков": "Uma semana de cafés da manhã saudáveis",
    "Несколько кадров из моей недели": "Algumas fotos da minha semana",
    "Ну что, узнали себя?": "E aí, se reconheceu?",
    "О чём пост": "Sobre o que é o post",
    "О чём пост?": "Sobre o que é o post?",
    "Обзоры, подборки и мода": "Resenhas, seleções e moda",
    "Окружение, которое поддерживает, и понятный план на неделю вперёд.": "Pessoas que apoiam e um plano claro para a semana.",
    "Осенний гардероб: вещи на весь сезон": "Guarda-roupa de outono: peças para a estação toda",
    "Остались вопросы?": "Ficou com dúvidas?",
    "Отметьте друга, который так делает": "Marque um amigo que faz isso",
    "Ошибки в беге": "Erros na corrida",
    "Панорама": "Panorama",
    "Первый шаг уже сделан": "O primeiro passo já foi dado",
    "Перед отпуском": "Antes das férias",
    "Перерисовываем слайд…": "Redesenhando o slide…",
    "Пишем подпись и хештеги": "Escrevendo a legenda e as hashtags",
    "Пишем текст слайдов": "Escrevendo o texto dos slides",
    "по одному на слайд, по кругу": "uma por slide, em ciclo",
    "Подписывайтесь: дальше больше пользы": "Siga: vem mais conteúdo útil",
    "Подпись готова": "Legenda pronta",
    "Подтвердите права на фото": "Confirme os direitos sobre as fotos",
    "Подтверждаю право использовать загружаемые фото": "Confirmo o direito de usar as fotos enviadas",
    "Подходит для": "Combina com",
    "Полезное": "Útil",
    "Пост-скриншот": "Captura de post",
    "Почему это важно": "Por que isso importa",
    "Пошаговые инструкции": "Instruções passo a passo",
    "Права на свои фото": "Direitos sobre suas fotos",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "A edição não foi confirmada. Continue verificando o mesmo pedido.",
    "Предпросмотр слайдов": "Pré-visualização dos slides",
    "Предыдущий слайд": "Slide anterior",
    "Пригодилось?": "Foi útil?",
    "Пригодится": "Vai ser útil",
    "Проверьте текст слайда: сервер его не принял.": "Verifique o texto do slide: o servidor não o aceitou.",
    "Простой приём": "Um truque simples",
    "пункт": "tópico",
    "пункта": "tópicos",
    "пунктов": "tópicos",
    "Путешествия, события и товары": "Viagens, eventos e produtos",
    "Пытаться сделать всё сразу. Маленький шаг каждый день лучше рывка раз в месяц.": "Tentar fazer tudo de uma vez. Um passo pequeno todo dia é melhor que um arranque uma vez por mês.",
    "Разберёмся, что даёт эта тема и почему о ней стоит знать уже сегодня.": "Vamos ver o que este tema traz e por que vale a pena conhecê-lo já hoje.",
    "Разбор": "Análise",
    "Разбор по пунктам": "Análise ponto a ponto",
    "Регулярность важнее идеальности. Начните с малого и не бросайте.": "Constância vale mais que perfeição. Comece pequeno e não desista.",
    "Рисуем иллюстрации": "Desenhando ilustrações",
    "С фото": "Com fotos",
    "С чего начать": "Por onde começar",
    "С юмором": "Com humor",
    "Самое важное": "O mais importante",
    "Свои фото": "Suas fotos",
    "Своя кофейня": "Cafeteria própria",
    "Сколько ждать результата? Первые перемены обычно видны через две-три недели.": "Quanto esperar pelo resultado? As primeiras mudanças costumam aparecer em duas ou três semanas.",
    "Сколько слайдов": "Quantos slides",
    "слайд": "slide",
    "Слайд {0} из {1}": "Slide {0} de {1}",
    "Слайд как пост в соцсети: аватар, имя, текст": "Slide como post de rede social: avatar, nome, texto",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "O slide já foi alterado. Atualizamos o resultado — confira o texto e salve de novo.",
    "слайда": "slides",
    "слайдов": "slides",
    "Слайды ещё загружаются": "Os slides ainda estão carregando",
    "Слайды собраны": "Slides montados",
    "Следующий слайд": "Próximo slide",
    "Смело и с вызовом": "Audacioso e desafiador",
    "Смотрим ваши фото": "Analisando suas fotos",
    "Собираем карусель": "Montando o carrossel",
    "Собираем слайды": "Montando os slides",
    "Советы и гайды": "Dicas e guias",
    "Создать карусель": "Criar carrossel",
    "Создать карусель · {0} C": "Criar carrossel · {0} C",
    "Сохраните": "Salve",
    "Сохраните и отправьте тому, кто тоже начинает": "Salve e envie para quem também está começando",
    "Сохраните и поделитесь": "Salve e compartilhe",
    "Сохраните и проверьте на себе": "Salve e teste em você",
    "Сохраните пост и вернитесь к нему, когда нужна поддержка": "Salve o post e volte a ele quando precisar de apoio",
    "Сохраните пост и начните завтра": "Salve o post e comece amanhã",
    "Сохраните пост и поделитесь им с друзьями": "Salve o post e compartilhe com os amigos",
    "Сохраните разбор": "Salve a análise",
    "Сохраните, пока не забыли": "Salve antes que esqueça",
    "Сохраните, пригодится": "Salve, vai ser útil",
    "Сохраните, чтобы не потерять": "Salve para não perder",
    "Списки": "Listas",
    "Спокойно, это лечится": "Calma, tem jeito",
    "Сравнивайте себя с собой месяц назад, а не с другими.": "Compare-se com você mesmo há um mês, não com os outros.",
    "стилей": "estilos",
    "Стили": "Estilos",
    "Стиль «{0}»": "Estilo «{0}»",
    "Стиль поста": "Estilo do post",
    "Стиль шаблона": "Estilo do modelo",
    "стиля": "estilo",
    "Текст выделен: скопируйте его вручную": "O texto está selecionado: copie-o manualmente",
    "Текст длиннее {0} знаков": "O texto tem mais de {0} caracteres",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "O texto não cabe no slide. Encurte o título ou o texto.",
    "Текст по вашим фото": "Texto a partir das suas fotos",
    "Текст слайда": "Texto do slide",
    "Тема не прошла проверку": "O tema não passou na verificação",
    "Тема разобрана": "Tema analisado",
    "Тёмный": "Escuro",
    "Только проверенные факты": "Só fatos verificados",
    "Тон": "Tom",
    "тон {0}": "tom {0}",
    "Тут откроется тема чата, куда бот прислал карусель": "Aqui vai abrir o tópico do chat onde o bot enviou o carrossel",
    "У вас получится": "Você vai conseguir",
    "У каждого слайда свой цвет и крупная цифра": "Cada slide com sua cor e um número grande",
    "Узнали себя? Листайте": "Se reconheceu? Deslize",
    "Факты и цифры без воды": "Fatos e números sem enrolação",
    "Фон и линия перетекают со слайда на слайд": "O fundo e a linha fluem de um slide para outro",
    "Фото и антиква, подписи как в журнале": "Fotos e fonte serifada, legendas de revista",
    "Фото на весь слайд": "Foto no slide inteiro",
    "Фото разобраны": "Fotos analisadas",
    "Хватит откладывать": "Chega de adiar",
    "Цветные блоки": "Blocos coloridos",
    "Цена": "Preço",
    "Цитата и история": "Citação e história",
    "Частый вопрос": "Pergunta frequente",
    "Чек-лист": "Checklist",
    "Чек-лист перед отпуском": "Checklist antes das férias",
    "Чек-листы и планы": "Checklists e planos",
    "Чёрный фон, светлый текст и один акцент": "Fundo preto, texto claro e um destaque",
    "Честно": "Sinceramente",
    "Честно и без прикрас": "Sincero e sem enfeites",
    "Читаем тему": "Lendo o tema",
    "Что запомнить": "O que lembrar",
    "Что поможет": "O que ajuda",
    "Шаг {0}": "Passo {0}",
    "Шаги с галочками и полоса прогресса": "Passos com marcas e barra de progresso",
    "Шпаргалки и личные советы": "Colas e dicas pessoais",
    "Экспертные посты и цифры": "Posts de especialista e números",
    "Этот вариант пока недоступен": "Esta opção ainda não está disponível",
    "Этот слайд больше нельзя изменить.": "Este slide não pode mais ser editado.",
    "Этот слайд нельзя изменить": "Este slide não pode ser editado"
  },
  "tr": {
    "{0} из {1} знаков": "{0} / {1} karakter",
    "5 ошибок новичка в беге": "Koşuya yeni başlayanların 5 hatası",
    "А другу отправьте, чтобы тоже не забыл": "Arkadaşınıza da gönderin, o da unutmasın",
    "Без воды и оправданий": "Laf kalabalığı ve bahane yok",
    "Без паники": "Panik yok",
    "Белый фон и крупный чёрный шрифт": "Beyaz arka plan ve büyük siyah yazı",
    "Бот уже прислал карусель с текстом поста в чат, в отдельную тему. Текст правится прямо на слайде, без новой генерации.": "Bot, karuseli gönderi metniyle birlikte sohbete ayrı bir konuda gönderdi. Metin yeni bir üretim olmadan doğrudan slaytta düzenlenir.",
    "Ваш ход": "Sıra sizde",
    "Ваши фото и текст на плашке": "Fotoğraflarınız ve bir şerit üzerinde metin",
    "Вдохновляющий": "İlham verici",
    "ВКонтакте и Telegram": "VK ve Telegram",
    "Все оформления": "Tüm tasarımlar",
    "встанут на слайды по порядку": "slaytlara sırayla yerleşir",
    "Выберите одно простое действие и сделайте его в ближайшие сутки.": "Basit bir eylem seçin ve önümüzdeki gün içinde yapın.",
    "Гардероб": "Gardırop",
    "Главная ошибка": "En büyük hata",
    "Дерзкий": "Cesur",
    "Для старта": "Başlangıç için",
    "До {0} фото, {1}": "En fazla {0} fotoğraf, {1}",
    "Журнал": "Dergi",
    "за карусель": "karusel başına",
    "Завтраки": "Kahvaltılar",
    "Заголовок слайда": "Slayt başlığı",
    "Загружаем фото": "Fotoğraflar yükleniyor",
    "Задайте их в комментариях, ответим": "Yorumlarda sorun, yanıtlayalım",
    "Заметки": "Notlar",
    "Запишите цель на видном месте и отмечайте каждый день, когда сделали шаг.": "Hedefinizi görünür bir yere yazın ve adım attığınız her günü işaretleyin.",
    "Заряжает начать": "Başlamak için enerji verir",
    "И отправьте другу, которому это пригодится": "Ve işine yarayacak bir arkadaşınıza gönderin",
    "Изменить стиль": "Stili değiştir",
    "Изменить текст": "Metni düzenle",
    "Изменить тему": "Konuyu değiştir",
    "Иллюстрации готовы": "İllüstrasyonlar hazır",
    "Искать среди {0} {1}": "{0} {1} arasında ara",
    "Истории": "Hikâyeler",
    "Истории с продолжением": "Devamı olan hikâyeler",
    "Каждый шаг считается": "Her adım önemlidir",
    "Как другу за кофе": "Kahve eşliğinde bir arkadaşa gibi",
    "Как мы открыли кофейню с нуля": "Sıfırdan nasıl kahveci açtık",
    "Как понять, что получается": "İşe yaradığı nasıl anlaşılır",
    "карусель": "karusel",
    "Карусель готова": "Karusel hazır",
    "Карусель для поста": "Gönderi karuseli",
    "карусель не создана": "karusel oluşturulmadı",
    "Коротко": "Kısa",
    "Коротко и по делу": "Kısa ve öz",
    "Коротко о главном": "Kısaca en önemlisi",
    "Крупная цитата, портрет и рассказ от первого лица": "Büyük alıntı, portre ve birinci ağızdan anlatım",
    "Лаконичный": "Özlü",
    "Легко и с улыбкой": "Hafif ve gülümseyerek",
    "Лист в линейку и выделение маркером": "Çizgili kâğıt ve fosforlu kalem",
    "Листайте": "Kaydırın",
    "Листайте, тут всё по делу": "Kaydırın, hepsi işe yarar",
    "Личные истории и отзывы": "Kişisel hikâyeler ve yorumlar",
    "Минимал": "Minimal",
    "Мифы о сне": "Uyku mitleri",
    "Мифы о сне, в которые пора перестать верить": "Artık inanmayı bırakmanız gereken uyku mitleri",
    "Мнения, истории и треды": "Görüşler, hikâyeler ve diziler",
    "Можно без темы: текст по фото": "Konu gerekmez: metin fotoğraflardan",
    "Можно вставить готовый текст": "Hazır metin yapıştırabilirsiniz",
    "Можно уйти с экрана: бот напишет, когда карусель будет готова.": "Ekrandan çıkabilirsiniz: karusel hazır olunca bot yazacak.",
    "на слайдах": "slaytlarda",
    "Напишите тему от {0} знаков или добавьте фото": "En az {0} karakterlik bir konu yazın veya fotoğraf ekleyin",
    "Например: {0}": "Örneğin: {0}",
    "Начните сегодня": "Bugün başlayın",
    "Не получилось собрать карусель": "Karusel hazırlanamadı",
    "Неделя полезных завтраков": "Bir haftalık sağlıklı kahvaltılar",
    "Несколько кадров из моей недели": "Haftamdan birkaç kare",
    "Ну что, узнали себя?": "Eee, kendinizi tanıdınız mı?",
    "О чём пост": "Gönderi ne hakkında",
    "О чём пост?": "Gönderi ne hakkında?",
    "Обзоры, подборки и мода": "İncelemeler, derlemeler ve moda",
    "Окружение, которое поддерживает, и понятный план на неделю вперёд.": "Destekleyen bir çevre ve önümüzdeki hafta için net bir plan.",
    "Осенний гардероб: вещи на весь сезон": "Sonbahar gardırobu: tüm sezonluk parçalar",
    "Остались вопросы?": "Sorunuz mu var?",
    "Отметьте друга, который так делает": "Bunu yapan bir arkadaşınızı etiketleyin",
    "Ошибки в беге": "Koşu hataları",
    "Панорама": "Panorama",
    "Первый шаг уже сделан": "İlk adım atıldı",
    "Перед отпуском": "Tatilden önce",
    "Перерисовываем слайд…": "Slayt yeniden çiziliyor…",
    "Пишем подпись и хештеги": "Açıklama ve hashtag yazıyoruz",
    "Пишем текст слайдов": "Slayt metnini yazıyoruz",
    "по одному на слайд, по кругу": "slayt başına bir, döngüyle",
    "Подписывайтесь: дальше больше пользы": "Takip edin: daha faydalısı geliyor",
    "Подпись готова": "Açıklama hazır",
    "Подтвердите права на фото": "Fotoğraf haklarını onaylayın",
    "Подтверждаю право использовать загружаемые фото": "Yüklenen fotoğrafları kullanma hakkını onaylıyorum",
    "Подходит для": "Uygun olduğu",
    "Полезное": "Faydalı",
    "Пост-скриншот": "Gönderi ekran görüntüsü",
    "Почему это важно": "Bu neden önemli",
    "Пошаговые инструкции": "Adım adım talimatlar",
    "Права на свои фото": "Fotoğraflarınızın hakları",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "Düzenleme onaylanmadı. Aynı isteği denetlemeye devam edin.",
    "Предпросмотр слайдов": "Slayt önizlemesi",
    "Предыдущий слайд": "Önceki slayt",
    "Пригодилось?": "İşinize yaradı mı?",
    "Пригодится": "İşinize yarar",
    "Проверьте текст слайда: сервер его не принял.": "Slayt metnini kontrol edin: sunucu kabul etmedi.",
    "Простой приём": "Basit bir yöntem",
    "пункт": "madde",
    "пункта": "madde",
    "пунктов": "madde",
    "Путешествия, события и товары": "Seyahat, etkinlikler ve ürünler",
    "Пытаться сделать всё сразу. Маленький шаг каждый день лучше рывка раз в месяц.": "Her şeyi bir anda yapmaya çalışmak. Her gün küçük bir adım, ayda bir atılımdan iyidir.",
    "Разберёмся, что даёт эта тема и почему о ней стоит знать уже сегодня.": "Bu konunun ne kazandırdığına ve neden bugün bilinmesi gerektiğine bakalım.",
    "Разбор": "Analiz",
    "Разбор по пунктам": "Madde madde analiz",
    "Регулярность важнее идеальности. Начните с малого и не бросайте.": "Düzenlilik mükemmellikten önemlidir. Küçük başlayın ve bırakmayın.",
    "Рисуем иллюстрации": "İllüstrasyonları çiziyoruz",
    "С фото": "Fotoğraflı",
    "С чего начать": "Nereden başlamalı",
    "С юмором": "Esprili",
    "Самое важное": "En önemlisi",
    "Свои фото": "Kendi fotoğraflarınız",
    "Своя кофейня": "Kendi kahvecin",
    "Сколько ждать результата? Первые перемены обычно видны через две-три недели.": "Sonuç için ne kadar beklemeli? İlk değişiklikler genellikle iki üç haftada görülür.",
    "Сколько слайдов": "Kaç slayt",
    "слайд": "slayt",
    "Слайд {0} из {1}": "Slayt {0} / {1}",
    "Слайд как пост в соцсети: аватар, имя, текст": "Sosyal medya gönderisi gibi slayt: avatar, ad, metin",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "Slayt zaten değiştirildi. Sonucu yeniledik — metni kontrol edip yeniden kaydedin.",
    "слайда": "slayt",
    "слайдов": "slayt",
    "Слайды ещё загружаются": "Slaytlar hâlâ yükleniyor",
    "Слайды собраны": "Slaytlar hazırlandı",
    "Следующий слайд": "Sonraki slayt",
    "Смело и с вызовом": "Cesur ve meydan okuyan",
    "Смотрим ваши фото": "Fotoğraflarınıza bakıyoruz",
    "Собираем карусель": "Karuseli hazırlıyoruz",
    "Собираем слайды": "Slaytlar oluşturuluyor",
    "Советы и гайды": "İpuçları ve rehberler",
    "Создать карусель": "Karusel oluştur",
    "Создать карусель · {0} C": "Karusel oluştur · {0} C",
    "Сохраните": "Kaydedin",
    "Сохраните и отправьте тому, кто тоже начинает": "Kaydedin ve yeni başlayan birine gönderin",
    "Сохраните и поделитесь": "Kaydedin ve paylaşın",
    "Сохраните и проверьте на себе": "Kaydedin ve kendinizde deneyin",
    "Сохраните пост и вернитесь к нему, когда нужна поддержка": "Gönderiyi kaydedin, desteğe ihtiyacınız olduğunda geri dönün",
    "Сохраните пост и начните завтра": "Gönderiyi kaydedin ve yarın başlayın",
    "Сохраните пост и поделитесь им с друзьями": "Gönderiyi kaydedin ve arkadaşlarınızla paylaşın",
    "Сохраните разбор": "Analizi kaydedin",
    "Сохраните, пока не забыли": "Unutmadan kaydedin",
    "Сохраните, пригодится": "Kaydedin, işinize yarar",
    "Сохраните, чтобы не потерять": "Kaybetmemek için kaydedin",
    "Списки": "Listeler",
    "Спокойно, это лечится": "Sakin olun, bunun çaresi var",
    "Сравнивайте себя с собой месяц назад, а не с другими.": "Kendinizi başkalarıyla değil, bir ay önceki halinizle karşılaştırın.",
    "стилей": "stil",
    "Стили": "Stiller",
    "Стиль «{0}»": "«{0}» stili",
    "Стиль поста": "Gönderi stili",
    "Стиль шаблона": "Şablon stili",
    "стиля": "stil",
    "Текст выделен: скопируйте его вручную": "Metin seçildi: elle kopyalayın",
    "Текст длиннее {0} знаков": "Metin {0} karakterden uzun",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "Metin slayta sığmıyor. Başlığı ya da metni kısaltın.",
    "Текст по вашим фото": "Fotoğraflarınızdan metin",
    "Текст слайда": "Slayt metni",
    "Тема не прошла проверку": "Konu kontrolden geçmedi",
    "Тема разобрана": "Konu incelendi",
    "Тёмный": "Koyu",
    "Только проверенные факты": "Yalnızca doğrulanmış gerçekler",
    "Тон": "Ton",
    "тон {0}": "{0} ton",
    "Тут откроется тема чата, куда бот прислал карусель": "Burada botun karuseli gönderdiği sohbet konusu açılacak",
    "У вас получится": "Başaracaksınız",
    "У каждого слайда свой цвет и крупная цифра": "Her slaytın kendi rengi ve büyük bir rakamı var",
    "Узнали себя? Листайте": "Kendinizi tanıdınız mı? Kaydırın",
    "Факты и цифры без воды": "Laf kalabalığı olmadan gerçekler ve rakamlar",
    "Фон и линия перетекают со слайда на слайд": "Arka plan ve çizgi slayttan slayta akar",
    "Фото и антиква, подписи как в журнале": "Fotoğraflar ve tırnaklı yazı, dergi gibi altyazılar",
    "Фото на весь слайд": "Tam slayt fotoğraf",
    "Фото разобраны": "Fotoğraflar incelendi",
    "Хватит откладывать": "Ertelemeyi bırakın",
    "Цветные блоки": "Renkli bloklar",
    "Цена": "Fiyat",
    "Цитата и история": "Alıntı ve hikâye",
    "Частый вопрос": "Sık sorulan soru",
    "Чек-лист": "Kontrol listesi",
    "Чек-лист перед отпуском": "Tatil öncesi kontrol listesi",
    "Чек-листы и планы": "Kontrol listeleri ve planlar",
    "Чёрный фон, светлый текст и один акцент": "Siyah arka plan, açık metin ve tek vurgu",
    "Честно": "Dürüstçe",
    "Честно и без прикрас": "Dürüst ve süssüz",
    "Читаем тему": "Konuyu okuyoruz",
    "Что запомнить": "Akılda tutulacaklar",
    "Что поможет": "Ne yardımcı olur",
    "Шаг {0}": "Adım {0}",
    "Шаги с галочками и полоса прогресса": "Onay işaretli adımlar ve ilerleme çubuğu",
    "Шпаргалки и личные советы": "Kopya kâğıtları ve kişisel ipuçları",
    "Экспертные посты и цифры": "Uzman gönderileri ve rakamlar",
    "Этот вариант пока недоступен": "Bu seçenek henüz kullanılamıyor",
    "Этот слайд больше нельзя изменить.": "Bu slayt artık düzenlenemez.",
    "Этот слайд нельзя изменить": "Bu slayt düzenlenemez"
  },
  "kk": {
    "{0} из {1} знаков": "{1} таңбаның {0}-і",
    "5 ошибок новичка в беге": "Жүгіруді жаңа бастаушының 5 қатесі",
    "А другу отправьте, чтобы тоже не забыл": "Ал досыңызға жіберіңіз, ол да ұмытпасын",
    "Без воды и оправданий": "Артық сөзсіз және ақталусыз",
    "Без паники": "Дүрбелеңсіз",
    "Белый фон и крупный чёрный шрифт": "Ақ фон және ірі қара қаріп",
    "Бот уже прислал карусель с текстом поста в чат, в отдельную тему. Текст правится прямо на слайде, без новой генерации.": "Бот каруселді пост мәтінімен бірге чатқа, бөлек тақырыпқа жіберді. Мәтін жаңа генерациясыз тікелей слайдта өңделеді.",
    "Ваш ход": "Сіздің кезегіңіз",
    "Ваши фото и текст на плашке": "Фотоларыңыз және тақтадағы мәтін",
    "Вдохновляющий": "Шабыттандыратын",
    "ВКонтакте и Telegram": "VK және Telegram",
    "Все оформления": "Барлық безендірулер",
    "встанут на слайды по порядку": "слайдтарға ретімен қойылады",
    "Выберите одно простое действие и сделайте его в ближайшие сутки.": "Бір қарапайым әрекетті таңдап, оны келесі тәулік ішінде орындаңыз.",
    "Гардероб": "Гардероб",
    "Главная ошибка": "Басты қате",
    "Дерзкий": "Батыл",
    "Для старта": "Бастау үшін",
    "До {0} фото, {1}": "{0} фотоға дейін, {1}",
    "Журнал": "Журнал",
    "за карусель": "карусель үшін",
    "Завтраки": "Таңғы астар",
    "Заголовок слайда": "Слайд тақырыбы",
    "Загружаем фото": "Фото жүктеліп жатыр",
    "Задайте их в комментариях, ответим": "Пікірлерде сұраңыз, жауап береміз",
    "Заметки": "Жазбалар",
    "Запишите цель на видном месте и отмечайте каждый день, когда сделали шаг.": "Мақсатты көрінетін жерге жазып, қадам жасаған әр күнді белгілеңіз.",
    "Заряжает начать": "Бастауға шабыт береді",
    "И отправьте другу, которому это пригодится": "Және бұл керек болатын досыңызға жіберіңіз",
    "Изменить стиль": "Стильді өзгерту",
    "Изменить текст": "Мәтінді өзгерту",
    "Изменить тему": "Тақырыпты өзгерту",
    "Иллюстрации готовы": "Иллюстрациялар дайын",
    "Искать среди {0} {1}": "{0} {1} ішінен іздеу",
    "Истории": "Оқиғалар",
    "Истории с продолжением": "Жалғасы бар оқиғалар",
    "Каждый шаг считается": "Әр қадам маңызды",
    "Как другу за кофе": "Досқа кофе үстінде айтқандай",
    "Как мы открыли кофейню с нуля": "Кофехананы нөлден қалай аштық",
    "Как понять, что получается": "Шығып жатқанын қалай түсінуге болады",
    "карусель": "карусель",
    "Карусель готова": "Карусель дайын",
    "Карусель для поста": "Постқа арналған карусель",
    "карусель не создана": "карусель жасалмады",
    "Коротко": "Қысқа",
    "Коротко и по делу": "Қысқа әрі нақты",
    "Коротко о главном": "Басты нәрсе қысқаша",
    "Крупная цитата, портрет и рассказ от первого лица": "Ірі дәйексөз, портрет және бірінші жақтан әңгіме",
    "Лаконичный": "Қысқа",
    "Легко и с улыбкой": "Жеңіл әрі күлкімен",
    "Лист в линейку и выделение маркером": "Сызықты парақ және маркермен белгілеу",
    "Листайте": "Парақтаңыз",
    "Листайте, тут всё по делу": "Парақтаңыз, бәрі нақты",
    "Личные истории и отзывы": "Жеке оқиғалар мен пікірлер",
    "Минимал": "Минимал",
    "Мифы о сне": "Ұйқы туралы мифтер",
    "Мифы о сне, в которые пора перестать верить": "Сенуді тоқтататын уақыт келген ұйқы туралы мифтер",
    "Мнения, истории и треды": "Пікірлер, оқиғалар мен тредтер",
    "Можно без темы: текст по фото": "Тақырыпсыз болады: мәтін фото бойынша",
    "Можно вставить готовый текст": "Дайын мәтінді қоюға болады",
    "Можно уйти с экрана: бот напишет, когда карусель будет готова.": "Экраннан кетуге болады: карусель дайын болғанда бот жазады.",
    "на слайдах": "слайдтарда",
    "Напишите тему от {0} знаков или добавьте фото": "{0} таңбадан бастап тақырып жазыңыз немесе фото қосыңыз",
    "Например: {0}": "Мысалы: {0}",
    "Начните сегодня": "Бүгін бастаңыз",
    "Не получилось собрать карусель": "Каруселді жинау мүмкін болмады",
    "Неделя полезных завтраков": "Пайдалы таңғы астар аптасы",
    "Несколько кадров из моей недели": "Аптамнан бірнеше кадр",
    "Ну что, узнали себя?": "Ал, өзіңізді таныдыңыз ба?",
    "О чём пост": "Пост не туралы",
    "О чём пост?": "Пост не туралы?",
    "Обзоры, подборки и мода": "Шолулар, топтамалар және сән",
    "Окружение, которое поддерживает, и понятный план на неделю вперёд.": "Қолдайтын орта және алдағы аптаға түсінікті жоспар.",
    "Осенний гардероб: вещи на весь сезон": "Күзгі гардероб: бүкіл маусымға арналған заттар",
    "Остались вопросы?": "Сұрақтар қалды ма?",
    "Отметьте друга, который так делает": "Осылай істейтін досыңызды белгілеңіз",
    "Ошибки в беге": "Жүгірудегі қателер",
    "Панорама": "Панорама",
    "Первый шаг уже сделан": "Алғашқы қадам жасалды",
    "Перед отпуском": "Демалыс алдында",
    "Перерисовываем слайд…": "Слайдты қайта саламыз…",
    "Пишем подпись и хештеги": "Жазба мен хэштегтерді жазып жатырмыз",
    "Пишем текст слайдов": "Слайд мәтінін жазып жатырмыз",
    "по одному на слайд, по кругу": "әр слайдқа біреуден, айналып",
    "Подписывайтесь: дальше больше пользы": "Жазылыңыз: алда пайдасы көбірек",
    "Подпись готова": "Жазба дайын",
    "Подтвердите права на фото": "Фотоға құқықты растаңыз",
    "Подтверждаю право использовать загружаемые фото": "Жүктелетін фотоларды пайдалану құқығын растаймын",
    "Подходит для": "Қандай тауарға",
    "Полезное": "Пайдалы",
    "Пост-скриншот": "Пост скриншоты",
    "Почему это важно": "Бұл неге маңызды",
    "Пошаговые инструкции": "Қадамдық нұсқаулар",
    "Права на свои фото": "Өз фотоларыңызға құқық",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "Түзету расталмады. Сол сұрауды тексеруді жалғастырыңыз.",
    "Предпросмотр слайдов": "Слайдтарды алдын ала қарау",
    "Предыдущий слайд": "Алдыңғы слайд",
    "Пригодилось?": "Пайдасы тиді ме?",
    "Пригодится": "Керек болады",
    "Проверьте текст слайда: сервер его не принял.": "Слайд мәтінін тексеріңіз: сервер оны қабылдамады.",
    "Простой приём": "Қарапайым тәсіл",
    "пункт": "тармақ",
    "пункта": "тармақ",
    "пунктов": "тармақ",
    "Путешествия, события и товары": "Саяхат, оқиғалар және тауарлар",
    "Пытаться сделать всё сразу. Маленький шаг каждый день лучше рывка раз в месяц.": "Бәрін бірден істеуге тырысу. Күн сайынғы кішкене қадам айына бір рет серпілуден жақсы.",
    "Разберёмся, что даёт эта тема и почему о ней стоит знать уже сегодня.": "Бұл тақырып не беретінін және ол туралы неге бүгін-ақ білу керектігін анықтайық.",
    "Разбор": "Талдау",
    "Разбор по пунктам": "Тармақ бойынша талдау",
    "Регулярность важнее идеальности. Начните с малого и не бросайте.": "Тұрақтылық мінсіздіктен маңызды. Кішіден бастап, тастамаңыз.",
    "Рисуем иллюстрации": "Иллюстрацияларды салып жатырмыз",
    "С фото": "Фотомен",
    "С чего начать": "Неден бастау керек",
    "С юмором": "Әзілмен",
    "Самое важное": "Ең маңыздысы",
    "Свои фото": "Өз фотоларыңыз",
    "Своя кофейня": "Өз кофеханаң",
    "Сколько ждать результата? Первые перемены обычно видны через две-три недели.": "Нәтижені қанша күту керек? Алғашқы өзгерістер әдетте екі-үш аптадан кейін көрінеді.",
    "Сколько слайдов": "Неше слайд",
    "слайд": "слайд",
    "Слайд {0} из {1}": "{1} слайдтың {0}-сі",
    "Слайд как пост в соцсети: аватар, имя, текст": "Әлеуметтік желі посты сияқты слайд: аватар, аты, мәтін",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "Слайд өзгертіліп қойған. Нәтижені жаңарттық — мәтінді тексеріп, қайта сақтаңыз.",
    "слайда": "слайд",
    "слайдов": "слайд",
    "Слайды ещё загружаются": "Слайдтар әлі жүктеліп жатыр",
    "Слайды собраны": "Слайдтар жиналды",
    "Следующий слайд": "Келесі слайд",
    "Смело и с вызовом": "Батыл әрі шақырумен",
    "Смотрим ваши фото": "Фотоларыңызды қарап жатырмыз",
    "Собираем карусель": "Каруселді жинап жатырмыз",
    "Собираем слайды": "Слайдтарды жинаймыз",
    "Советы и гайды": "Кеңестер мен нұсқаулықтар",
    "Создать карусель": "Карусель жасау",
    "Создать карусель · {0} C": "Карусель жасау · {0} C",
    "Сохраните": "Сақтаңыз",
    "Сохраните и отправьте тому, кто тоже начинает": "Сақтап, бастап жүрген адамға жіберіңіз",
    "Сохраните и поделитесь": "Сақтап, бөлісіңіз",
    "Сохраните и проверьте на себе": "Сақтап, өзіңізде тексеріңіз",
    "Сохраните пост и вернитесь к нему, когда нужна поддержка": "Постты сақтап, қолдау керек кезде оған оралыңыз",
    "Сохраните пост и начните завтра": "Постты сақтап, ертең бастаңыз",
    "Сохраните пост и поделитесь им с друзьями": "Постты сақтап, достарыңызбен бөлісіңіз",
    "Сохраните разбор": "Талдауды сақтаңыз",
    "Сохраните, пока не забыли": "Ұмытпай тұрып сақтаңыз",
    "Сохраните, пригодится": "Сақтап қойыңыз, керек болады",
    "Сохраните, чтобы не потерять": "Жоғалтпау үшін сақтаңыз",
    "Списки": "Тізімдер",
    "Спокойно, это лечится": "Сабыр, бұл емделеді",
    "Сравнивайте себя с собой месяц назад, а не с другими.": "Өзіңізді басқалармен емес, бір ай бұрынғы өзіңізбен салыстырыңыз.",
    "стилей": "стиль",
    "Стили": "Стильдер",
    "Стиль «{0}»": "«{0}» стилі",
    "Стиль поста": "Пост стилі",
    "Стиль шаблона": "Үлгі стилі",
    "стиля": "стиль",
    "Текст выделен: скопируйте его вручную": "Мәтін белгіленді: оны қолмен көшіріңіз",
    "Текст длиннее {0} знаков": "Мәтін {0} таңбадан ұзын",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "Мәтін слайдқа сыймайды. Тақырыпты немесе мәтінді қысқартыңыз.",
    "Текст по вашим фото": "Фотоларыңыз бойынша мәтін",
    "Текст слайда": "Слайд мәтіні",
    "Тема не прошла проверку": "Тақырып тексеруден өтпеді",
    "Тема разобрана": "Тақырып талданды",
    "Тёмный": "Қараңғы",
    "Только проверенные факты": "Тек тексерілген деректер",
    "Тон": "Тон",
    "тон {0}": "{0} үн",
    "Тут откроется тема чата, куда бот прислал карусель": "Мұнда бот карусель жіберген чат тақырыбы ашылады",
    "У вас получится": "Сіздің қолыңыздан келеді",
    "У каждого слайда свой цвет и крупная цифра": "Әр слайдтың өз түсі және ірі саны бар",
    "Узнали себя? Листайте": "Өзіңізді таныдыңыз ба? Парақтаңыз",
    "Факты и цифры без воды": "Артық сөзсіз деректер мен сандар",
    "Фон и линия перетекают со слайда на слайд": "Фон мен сызық слайдтан слайдқа ағып өтеді",
    "Фото и антиква, подписи как в журнале": "Фото және антиква, журналдағыдай жазулар",
    "Фото на весь слайд": "Бүкіл слайдқа фото",
    "Фото разобраны": "Фотолар қаралды",
    "Хватит откладывать": "Кейінге қалдыруды доғарыңыз",
    "Цветные блоки": "Түсті блоктар",
    "Цена": "Бағасы",
    "Цитата и история": "Дәйексөз және оқиға",
    "Частый вопрос": "Жиі қойылатын сұрақ",
    "Чек-лист": "Чек-парақ",
    "Чек-лист перед отпуском": "Демалыс алдындағы чек-парақ",
    "Чек-листы и планы": "Чек-парақтар мен жоспарлар",
    "Чёрный фон, светлый текст и один акцент": "Қара фон, ашық мәтін және бір екпін",
    "Честно": "Шынымен",
    "Честно и без прикрас": "Шынайы әрі әсірелеусіз",
    "Читаем тему": "Тақырыпты оқып жатырмыз",
    "Что запомнить": "Нені есте сақтау керек",
    "Что поможет": "Не көмектеседі",
    "Шаг {0}": "{0}-қадам",
    "Шаги с галочками и полоса прогресса": "Белгіленген қадамдар және прогресс жолағы",
    "Шпаргалки и личные советы": "Шпаргалкалар мен жеке кеңестер",
    "Экспертные посты и цифры": "Сарапшы посттары мен сандар",
    "Этот вариант пока недоступен": "Бұл нұсқа әзірге қолжетімсіз",
    "Этот слайд больше нельзя изменить.": "Бұл слайдты енді өзгерту мүмкін емес.",
    "Этот слайд нельзя изменить": "Бұл слайдты өзгерту мүмкін емес"
  },
  "uk": {
    "{0} из {1} знаков": "{0} з {1} знаків",
    "5 ошибок новичка в беге": "5 помилок новачка в бігу",
    "А другу отправьте, чтобы тоже не забыл": "А другові надішліть, щоб теж не забув",
    "Без воды и оправданий": "Без води й виправдань",
    "Без паники": "Без паніки",
    "Белый фон и крупный чёрный шрифт": "Білий фон і великий чорний шрифт",
    "Бот уже прислал карусель с текстом поста в чат, в отдельную тему. Текст правится прямо на слайде, без новой генерации.": "Бот уже надіслав карусель із текстом допису в чат, в окрему тему. Текст правиться просто на слайді, без нової генерації.",
    "Ваш ход": "Ваш хід",
    "Ваши фото и текст на плашке": "Ваші фото й текст на плашці",
    "Вдохновляющий": "Надихаючий",
    "ВКонтакте и Telegram": "ВКонтакте й Telegram",
    "Все оформления": "Усі оформлення",
    "встанут на слайды по порядку": "стануть на слайди по черзі",
    "Выберите одно простое действие и сделайте его в ближайшие сутки.": "Оберіть одну просту дію і зробіть її найближчої доби.",
    "Гардероб": "Гардероб",
    "Главная ошибка": "Головна помилка",
    "Дерзкий": "Зухвалий",
    "Для старта": "Для старту",
    "До {0} фото, {1}": "До {0} фото, {1}",
    "Журнал": "Журнал",
    "за карусель": "за карусель",
    "Завтраки": "Сніданки",
    "Заголовок слайда": "Заголовок слайда",
    "Загружаем фото": "Завантажуємо фото",
    "Задайте их в комментариях, ответим": "Поставте їх у коментарях, відповімо",
    "Заметки": "Нотатки",
    "Запишите цель на видном месте и отмечайте каждый день, когда сделали шаг.": "Запишіть мету на видному місці й позначайте кожен день, коли зробили крок.",
    "Заряжает начать": "Заряджає почати",
    "И отправьте другу, которому это пригодится": "І надішліть другові, якому це знадобиться",
    "Изменить стиль": "Змінити стиль",
    "Изменить текст": "Змінити текст",
    "Изменить тему": "Змінити тему",
    "Иллюстрации готовы": "Ілюстрації готові",
    "Искать среди {0} {1}": "Шукати серед {0} {1}",
    "Истории": "Історії",
    "Истории с продолжением": "Історії з продовженням",
    "Каждый шаг считается": "Кожен крок важливий",
    "Как другу за кофе": "Як другові за кавою",
    "Как мы открыли кофейню с нуля": "Як ми відкрили кавʼярню з нуля",
    "Как понять, что получается": "Як зрозуміти, що виходить",
    "карусель": "карусель",
    "Карусель готова": "Карусель готова",
    "Карусель для поста": "Карусель для допису",
    "карусель не создана": "карусель не створено",
    "Коротко": "Коротко",
    "Коротко и по делу": "Коротко й по суті",
    "Коротко о главном": "Коротко про головне",
    "Крупная цитата, портрет и рассказ от первого лица": "Велика цитата, портрет і розповідь від першої особи",
    "Лаконичный": "Лаконічний",
    "Легко и с улыбкой": "Легко й з усмішкою",
    "Лист в линейку и выделение маркером": "Аркуш у лінійку й виділення маркером",
    "Листайте": "Гортайте",
    "Листайте, тут всё по делу": "Гортайте, тут усе по суті",
    "Личные истории и отзывы": "Особисті історії й відгуки",
    "Минимал": "Мінімал",
    "Мифы о сне": "Міфи про сон",
    "Мифы о сне, в которые пора перестать верить": "Міфи про сон, у які час перестати вірити",
    "Мнения, истории и треды": "Думки, історії та треди",
    "Можно без темы: текст по фото": "Можна без теми: текст за фото",
    "Можно вставить готовый текст": "Можна вставити готовий текст",
    "Можно уйти с экрана: бот напишет, когда карусель будет готова.": "Можна піти з екрана: бот напише, коли карусель буде готова.",
    "на слайдах": "на слайдах",
    "Напишите тему от {0} знаков или добавьте фото": "Напишіть тему від {0} знаків або додайте фото",
    "Например: {0}": "Наприклад: {0}",
    "Начните сегодня": "Почніть сьогодні",
    "Не получилось собрать карусель": "Не вдалося зібрати карусель",
    "Неделя полезных завтраков": "Тиждень корисних сніданків",
    "Несколько кадров из моей недели": "Кілька кадрів із мого тижня",
    "Ну что, узнали себя?": "Ну що, впізнали себе?",
    "О чём пост": "Про що допис",
    "О чём пост?": "Про що допис?",
    "Обзоры, подборки и мода": "Огляди, добірки й мода",
    "Окружение, которое поддерживает, и понятный план на неделю вперёд.": "Оточення, яке підтримує, і зрозумілий план на тиждень уперед.",
    "Осенний гардероб: вещи на весь сезон": "Осінній гардероб: речі на весь сезон",
    "Остались вопросы?": "Залишилися питання?",
    "Отметьте друга, который так делает": "Позначте друга, який так робить",
    "Ошибки в беге": "Помилки в бігу",
    "Панорама": "Панорама",
    "Первый шаг уже сделан": "Перший крок уже зроблено",
    "Перед отпуском": "Перед відпусткою",
    "Перерисовываем слайд…": "Перемальовуємо слайд…",
    "Пишем подпись и хештеги": "Пишемо підпис і хештеги",
    "Пишем текст слайдов": "Пишемо текст слайдів",
    "по одному на слайд, по кругу": "по одному на слайд, по колу",
    "Подписывайтесь: дальше больше пользы": "Підписуйтеся: далі більше користі",
    "Подпись готова": "Підпис готовий",
    "Подтвердите права на фото": "Підтвердьте права на фото",
    "Подтверждаю право использовать загружаемые фото": "Підтверджую право використовувати завантажені фото",
    "Подходит для": "Підходить для",
    "Полезное": "Корисне",
    "Пост-скриншот": "Допис-скриншот",
    "Почему это важно": "Чому це важливо",
    "Пошаговые инструкции": "Покрокові інструкції",
    "Права на свои фото": "Права на свої фото",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "Правку не підтверджено. Продовжте перевірку того самого запиту.",
    "Предпросмотр слайдов": "Попередній перегляд слайдів",
    "Предыдущий слайд": "Попередній слайд",
    "Пригодилось?": "Знадобилося?",
    "Пригодится": "Знадобиться",
    "Проверьте текст слайда: сервер его не принял.": "Перевірте текст слайда: сервер його не прийняв.",
    "Простой приём": "Простий прийом",
    "пункт": "пункт",
    "пункта": "пункти",
    "пунктов": "пунктів",
    "Путешествия, события и товары": "Подорожі, події й товари",
    "Пытаться сделать всё сразу. Маленький шаг каждый день лучше рывка раз в месяц.": "Намагатися зробити все одразу. Маленький крок щодня кращий за ривок раз на місяць.",
    "Разберёмся, что даёт эта тема и почему о ней стоит знать уже сегодня.": "Розберімося, що дає ця тема і чому про неї варто знати вже сьогодні.",
    "Разбор": "Розбір",
    "Разбор по пунктам": "Розбір за пунктами",
    "Регулярность важнее идеальности. Начните с малого и не бросайте.": "Регулярність важливіша за ідеальність. Почніть із малого й не кидайте.",
    "Рисуем иллюстрации": "Малюємо ілюстрації",
    "С фото": "З фото",
    "С чего начать": "З чого почати",
    "С юмором": "З гумором",
    "Самое важное": "Найважливіше",
    "Свои фото": "Свої фото",
    "Своя кофейня": "Своя кавʼярня",
    "Сколько ждать результата? Первые перемены обычно видны через две-три недели.": "Скільки чекати результату? Перші зміни зазвичай видно за два-три тижні.",
    "Сколько слайдов": "Скільки слайдів",
    "слайд": "слайд",
    "Слайд {0} из {1}": "Слайд {0} з {1}",
    "Слайд как пост в соцсети: аватар, имя, текст": "Слайд як допис у соцмережі: аватар, імʼя, текст",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "Слайд уже змінено. Ми оновили результат — перевірте текст і збережіть знову.",
    "слайда": "слайди",
    "слайдов": "слайдів",
    "Слайды ещё загружаются": "Слайди ще завантажуються",
    "Слайды собраны": "Слайди зібрано",
    "Следующий слайд": "Наступний слайд",
    "Смело и с вызовом": "Сміливо й з викликом",
    "Смотрим ваши фото": "Переглядаємо ваші фото",
    "Собираем карусель": "Збираємо карусель",
    "Собираем слайды": "Збираємо слайди",
    "Советы и гайды": "Поради й гайди",
    "Создать карусель": "Створити карусель",
    "Создать карусель · {0} C": "Створити карусель · {0} C",
    "Сохраните": "Збережіть",
    "Сохраните и отправьте тому, кто тоже начинает": "Збережіть і надішліть тому, хто теж починає",
    "Сохраните и поделитесь": "Збережіть і поділіться",
    "Сохраните и проверьте на себе": "Збережіть і перевірте на собі",
    "Сохраните пост и вернитесь к нему, когда нужна поддержка": "Збережіть допис і повертайтеся до нього, коли потрібна підтримка",
    "Сохраните пост и начните завтра": "Збережіть допис і почніть завтра",
    "Сохраните пост и поделитесь им с друзьями": "Збережіть допис і поділіться з друзями",
    "Сохраните разбор": "Збережіть розбір",
    "Сохраните, пока не забыли": "Збережіть, поки не забули",
    "Сохраните, пригодится": "Збережіть, знадобиться",
    "Сохраните, чтобы не потерять": "Збережіть, щоб не загубити",
    "Списки": "Списки",
    "Спокойно, это лечится": "Спокійно, це лікується",
    "Сравнивайте себя с собой месяц назад, а не с другими.": "Порівнюйте себе із собою місяць тому, а не з іншими.",
    "стилей": "стилів",
    "Стили": "Стилі",
    "Стиль «{0}»": "Стиль «{0}»",
    "Стиль поста": "Стиль допису",
    "Стиль шаблона": "Стиль шаблону",
    "стиля": "стилю",
    "Текст выделен: скопируйте его вручную": "Текст виділено: скопіюйте його вручну",
    "Текст длиннее {0} знаков": "Текст довший за {0} знаків",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "Текст не вміщується на слайд. Скоротіть заголовок або текст.",
    "Текст по вашим фото": "Текст за вашими фото",
    "Текст слайда": "Текст слайда",
    "Тема не прошла проверку": "Тема не пройшла перевірку",
    "Тема разобрана": "Тему розібрано",
    "Тёмный": "Темний",
    "Только проверенные факты": "Лише перевірені факти",
    "Тон": "Тон",
    "тон {0}": "тон {0}",
    "Тут откроется тема чата, куда бот прислал карусель": "Тут відкриється тема чату, куди бот надіслав карусель",
    "У вас получится": "У вас вийде",
    "У каждого слайда свой цвет и крупная цифра": "У кожного слайда свій колір і велика цифра",
    "Узнали себя? Листайте": "Впізнали себе? Гортайте",
    "Факты и цифры без воды": "Факти й цифри без води",
    "Фон и линия перетекают со слайда на слайд": "Фон і лінія перетікають зі слайда на слайд",
    "Фото и антиква, подписи как в журнале": "Фото й антиква, підписи як у журналі",
    "Фото на весь слайд": "Фото на весь слайд",
    "Фото разобраны": "Фото переглянуто",
    "Хватит откладывать": "Досить відкладати",
    "Цветные блоки": "Кольорові блоки",
    "Цена": "Ціна",
    "Цитата и история": "Цитата й історія",
    "Частый вопрос": "Часте питання",
    "Чек-лист": "Чек-лист",
    "Чек-лист перед отпуском": "Чек-лист перед відпусткою",
    "Чек-листы и планы": "Чек-листи й плани",
    "Чёрный фон, светлый текст и один акцент": "Чорний фон, світлий текст і один акцент",
    "Честно": "Чесно",
    "Честно и без прикрас": "Чесно й без прикрас",
    "Читаем тему": "Читаємо тему",
    "Что запомнить": "Що запамʼятати",
    "Что поможет": "Що допоможе",
    "Шаг {0}": "Крок {0}",
    "Шаги с галочками и полоса прогресса": "Кроки з позначками й смуга прогресу",
    "Шпаргалки и личные советы": "Шпаргалки й особисті поради",
    "Экспертные посты и цифры": "Експертні дописи й цифри",
    "Этот вариант пока недоступен": "Цей варіант поки недоступний",
    "Этот слайд больше нельзя изменить.": "Цей слайд більше не можна змінити.",
    "Этот слайд нельзя изменить": "Цей слайд не можна змінити"
  },
  "zh": {
    "{0} из {1} знаков": "{0} / {1} 字",
    "5 ошибок новичка в беге": "跑步新手常犯的 5 个错误",
    "А другу отправьте, чтобы тоже не забыл": "也发给朋友，免得他忘了",
    "Без воды и оправданий": "不说废话，不找借口",
    "Без паники": "别慌",
    "Белый фон и крупный чёрный шрифт": "白色背景配大号黑字",
    "Бот уже прислал карусель с текстом поста в чат, в отдельную тему. Текст правится прямо на слайде, без новой генерации.": "机器人已把轮播图和帖子文案发到聊天的单独话题中。文字可直接在幻灯片上修改，无需重新生成。",
    "Ваш ход": "轮到你了",
    "Ваши фото и текст на плашке": "你的照片配文字卡片",
    "Вдохновляющий": "励志",
    "ВКонтакте и Telegram": "VK 和 Telegram",
    "Все оформления": "全部设计",
    "встанут на слайды по порядку": "将按顺序放入幻灯片",
    "Выберите одно простое действие и сделайте его в ближайшие сутки.": "选一个简单的行动，在接下来一天内完成。",
    "Гардероб": "衣橱",
    "Главная ошибка": "最大的错误",
    "Дерзкий": "大胆",
    "Для старта": "入门",
    "До {0} фото, {1}": "最多 {0} 张照片，{1}",
    "Журнал": "杂志",
    "за карусель": "每个轮播图",
    "Завтраки": "早餐",
    "Заголовок слайда": "幻灯片标题",
    "Загружаем фото": "正在上传照片",
    "Задайте их в комментариях, ответим": "在评论里提问，我们会回答",
    "Заметки": "笔记",
    "Запишите цель на видном месте и отмечайте каждый день, когда сделали шаг.": "把目标写在显眼的地方，每天迈出一步就打个勾。",
    "Заряжает начать": "激励你开始行动",
    "И отправьте другу, которому это пригодится": "也发给需要它的朋友",
    "Изменить стиль": "修改风格",
    "Изменить текст": "修改文字",
    "Изменить тему": "修改主题",
    "Иллюстрации готовы": "插图已完成",
    "Искать среди {0} {1}": "在 {0} 个{1}中搜索",
    "Истории": "故事",
    "Истории с продолжением": "连载故事",
    "Каждый шаг считается": "每一步都算数",
    "Как другу за кофе": "像和朋友喝咖啡聊天",
    "Как мы открыли кофейню с нуля": "我们如何从零开起一家咖啡馆",
    "Как понять, что получается": "怎么知道有效果",
    "карусель": "轮播",
    "Карусель готова": "轮播图已完成",
    "Карусель для поста": "帖子轮播图",
    "карусель не создана": "轮播图未生成",
    "Коротко": "简短",
    "Коротко и по делу": "简短直接",
    "Коротко о главном": "要点速览",
    "Крупная цитата, портрет и рассказ от первого лица": "大号引言、人像和第一人称故事",
    "Лаконичный": "简洁",
    "Легко и с улыбкой": "轻松幽默",
    "Лист в линейку и выделение маркером": "横线纸配荧光笔标记",
    "Листайте": "滑动查看",
    "Листайте, тут всё по делу": "滑动查看，全是干货",
    "Личные истории и отзывы": "个人故事和评价",
    "Минимал": "极简",
    "Мифы о сне": "关于睡眠的误区",
    "Мифы о сне, в которые пора перестать верить": "是时候别再相信的睡眠误区",
    "Мнения, истории и треды": "观点、故事和长帖",
    "Можно без темы: текст по фото": "可以不写主题：根据照片生成文案",
    "Можно вставить готовый текст": "可以粘贴现成文字",
    "Можно уйти с экрана: бот напишет, когда карусель будет готова.": "可以离开此页面：轮播图完成后机器人会通知你。",
    "на слайдах": "在幻灯片上",
    "Напишите тему от {0} знаков или добавьте фото": "写一个至少 {0} 个字的主题或添加照片",
    "Например: {0}": "例如：{0}",
    "Начните сегодня": "今天就开始",
    "Не получилось собрать карусель": "轮播图生成失败",
    "Неделя полезных завтраков": "一周健康早餐",
    "Несколько кадров из моей недели": "我这一周的几个瞬间",
    "Ну что, узнали себя?": "怎么样，是不是说的你？",
    "О чём пост": "帖子讲什么",
    "О чём пост?": "帖子讲什么？",
    "Обзоры, подборки и мода": "测评、合集和穿搭",
    "Окружение, которое поддерживает, и понятный план на неделю вперёд.": "支持你的人，以及未来一周的清晰计划。",
    "Осенний гардероб: вещи на весь сезон": "秋季衣橱：穿一整季的单品",
    "Остались вопросы?": "还有问题吗？",
    "Отметьте друга, который так делает": "@一个这样做的朋友",
    "Ошибки в беге": "跑步误区",
    "Панорама": "全景",
    "Первый шаг уже сделан": "第一步已经迈出",
    "Перед отпуском": "假期前",
    "Перерисовываем слайд…": "正在重绘幻灯片…",
    "Пишем подпись и хештеги": "正在写配文和话题标签",
    "Пишем текст слайдов": "正在写幻灯片文字",
    "по одному на слайд, по кругу": "每张幻灯片一个，循环使用",
    "Подписывайтесь: дальше больше пользы": "关注我，更多干货在后面",
    "Подпись готова": "配文已完成",
    "Подтвердите права на фото": "请确认照片使用权",
    "Подтверждаю право использовать загружаемые фото": "我确认有权使用上传的照片",
    "Подходит для": "适用于",
    "Полезное": "干货",
    "Пост-скриншот": "帖子截图",
    "Почему это важно": "为什么重要",
    "Пошаговые инструкции": "分步指南",
    "Права на свои фото": "照片使用权",
    "Правка не подтверждена. Продолжите проверку того же запроса.": "修改尚未确认。请继续检查同一请求。",
    "Предпросмотр слайдов": "幻灯片预览",
    "Предыдущий слайд": "上一张幻灯片",
    "Пригодилось?": "有用吗？",
    "Пригодится": "用得上",
    "Проверьте текст слайда: сервер его не принял.": "请检查幻灯片文字：服务器未接受。",
    "Простой приём": "一个简单技巧",
    "пункт": "条",
    "пункта": "条",
    "пунктов": "条",
    "Путешествия, события и товары": "旅行、活动和商品",
    "Пытаться сделать всё сразу. Маленький шаг каждый день лучше рывка раз в месяц.": "想一下子做完所有事。每天一小步胜过每月冲刺一次。",
    "Разберёмся, что даёт эта тема и почему о ней стоит знать уже сегодня.": "来看看这个话题能带来什么，以及为什么今天就值得了解。",
    "Разбор": "解析",
    "Разбор по пунктам": "逐条解析",
    "Регулярность важнее идеальности. Начните с малого и не бросайте.": "坚持比完美更重要。从小事做起，不要放弃。",
    "Рисуем иллюстрации": "正在绘制插图",
    "С фото": "用照片",
    "С чего начать": "从哪里开始",
    "С юмором": "幽默",
    "Самое важное": "最重要的",
    "Свои фото": "自己的照片",
    "Своя кофейня": "自己的咖啡馆",
    "Сколько ждать результата? Первые перемены обычно видны через две-три недели.": "多久能看到效果？通常两三周就能看到初步变化。",
    "Сколько слайдов": "幻灯片数量",
    "слайд": "张幻灯片",
    "Слайд {0} из {1}": "第 {0} / {1} 张幻灯片",
    "Слайд как пост в соцсети: аватар, имя, текст": "像社交帖子一样的幻灯片：头像、名字、正文",
    "Слайд уже изменён. Мы обновили итог — проверьте текст и сохраните снова.": "幻灯片已被修改。我们刷新了结果，请检查文字后再次保存。",
    "слайда": "张幻灯片",
    "слайдов": "张幻灯片",
    "Слайды ещё загружаются": "幻灯片仍在加载",
    "Слайды собраны": "幻灯片已合成",
    "Следующий слайд": "下一张幻灯片",
    "Смело и с вызовом": "大胆挑衅",
    "Смотрим ваши фото": "正在查看你的照片",
    "Собираем карусель": "正在制作轮播图",
    "Собираем слайды": "正在生成幻灯片",
    "Советы и гайды": "技巧与指南",
    "Создать карусель": "创建轮播图",
    "Создать карусель · {0} C": "创建轮播图 · {0} C",
    "Сохраните": "收藏",
    "Сохраните и отправьте тому, кто тоже начинает": "收藏并发给同样刚起步的人",
    "Сохраните и поделитесь": "收藏并分享",
    "Сохраните и проверьте на себе": "收藏并亲自试试",
    "Сохраните пост и вернитесь к нему, когда нужна поддержка": "收藏这篇帖子，需要鼓励时再回来看",
    "Сохраните пост и начните завтра": "收藏这篇帖子，明天就开始",
    "Сохраните пост и поделитесь им с друзьями": "收藏这篇帖子并分享给朋友",
    "Сохраните разбор": "收藏这篇解析",
    "Сохраните, пока не забыли": "趁还没忘，先收藏",
    "Сохраните, пригодится": "收藏起来，用得上",
    "Сохраните, чтобы не потерять": "收藏起来，以免找不到",
    "Списки": "清单",
    "Спокойно, это лечится": "别担心，这能解决",
    "Сравнивайте себя с собой месяц назад, а не с другими.": "和一个月前的自己比，而不是和别人比。",
    "стилей": "种风格",
    "Стили": "风格",
    "Стиль «{0}»": "风格「{0}」",
    "Стиль поста": "帖子风格",
    "Стиль шаблона": "模板风格",
    "стиля": "种风格",
    "Текст выделен: скопируйте его вручную": "文本已选中：请手动复制",
    "Текст длиннее {0} знаков": "文字超过 {0} 个字符",
    "Текст не помещается на слайд. Сократите заголовок или текст.": "文字放不下这张幻灯片。请缩短标题或正文。",
    "Текст по вашим фото": "根据你的照片生成文案",
    "Текст слайда": "幻灯片文字",
    "Тема не прошла проверку": "主题未通过审核",
    "Тема разобрана": "主题已分析",
    "Тёмный": "深色",
    "Только проверенные факты": "只用经过核实的事实",
    "Тон": "语气",
    "тон {0}": "{0}语气",
    "Тут откроется тема чата, куда бот прислал карусель": "这里会打开机器人发送轮播图的聊天话题",
    "У вас получится": "你一定能做到",
    "У каждого слайда свой цвет и крупная цифра": "每张幻灯片都有自己的颜色和大号数字",
    "Узнали себя? Листайте": "是不是说的你？滑动查看",
    "Факты и цифры без воды": "事实和数据，不说废话",
    "Фон и линия перетекают со слайда на слайд": "背景和线条在幻灯片之间连贯过渡",
    "Фото и антиква, подписи как в журнале": "照片配衬线字体，杂志风格配文",
    "Фото на весь слайд": "满版照片",
    "Фото разобраны": "照片已分析",
    "Хватит откладывать": "别再拖了",
    "Цветные блоки": "彩色色块",
    "Цена": "价格",
    "Цитата и история": "引言与故事",
    "Частый вопрос": "常见问题",
    "Чек-лист": "清单",
    "Чек-лист перед отпуском": "假期前清单",
    "Чек-листы и планы": "清单与计划",
    "Чёрный фон, светлый текст и один акцент": "黑色背景、浅色文字和一个强调色",
    "Честно": "说实话",
    "Честно и без прикрас": "真实不加修饰",
    "Читаем тему": "正在阅读主题",
    "Что запомнить": "要记住的",
    "Что поможет": "有帮助的",
    "Шаг {0}": "第 {0} 步",
    "Шаги с галочками и полоса прогресса": "带勾选的步骤和进度条",
    "Шпаргалки и личные советы": "速查表和个人建议",
    "Экспертные посты и цифры": "专业帖子和数据",
    "Этот вариант пока недоступен": "此选项暂不可用",
    "Этот слайд больше нельзя изменить.": "此幻灯片已无法修改。",
    "Этот слайд нельзя изменить": "此幻灯片无法修改"
  }
}
